import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Card,
  Dropdown,
  Form,
  Modal,
  Nav,
  Spinner,
  Tab,
} from "react-bootstrap";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import ParticipantCard from "./components/ParticipantCard";
import StepCard from "./components/StepCard";
import StepFile from "./components/StepFile";
import HostCard from "./components/HostCard";
import InviteStepChart from "./components/InviteStepChart";
import axios from "axios";
import { API_BASE_URL, Assets_URL } from "../../../Apicongfig";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { FaArrowRight } from "react-icons/fa6";
import { RiEditBoxLine } from "react-icons/ri";
import { AiOutlineDelete, AiOutlineEye } from "react-icons/ai";
import { IoArrowBackSharp, IoCopyOutline } from "react-icons/io5";
import { BiDotsVerticalRounded } from "react-icons/bi";
import moment from "moment";
import { ImCancelCircle } from "react-icons/im";
import { LuLink } from "react-icons/lu";
import copy from "copy-to-clipboard";
import { openLinkInNewTab } from "../../../Utils/openLinkInNewTab";
import { useSteps } from "../../../../context/Step";
import { FaChartGantt } from "react-icons/fa6";
import { FaList, FaRegCheckSquare } from "react-icons/fa";
import ConfirmationModal from "../../../Utils/ConfirmationModal";
import {
  convertTimeTakenToSeconds,
  markTodoMeeting,
} from "../../../Utils/MeetingFunctions";
import { useMeetings } from "../../../../context/MeetingsContext";
import { useFormContext } from "../../../../context/CreateMeetingContext";
import NewMeetingModal from "../CreateNewMeeting/NewMeetingModal";
import StepChart from "../CreateNewMeeting/StepChart";
import { BsPersonWorkspace } from "react-icons/bs";
import { FaPhoneAlt } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import { Avatar, Tooltip } from "antd";
import FileUploadModal from "../CreateNewMeeting/FileUploadModal";
import ViewFilePreview from "../ViewFilePreview";

import {
  formatTime,
  formatDate,
  parseAndFormatDateTime,
  calculateEndDate,
  calculateTotalTime,
  convertCount2ToSeconds,
  handleCopy,
  convertDateToUserTimezone,
  timezoneSymbols,
  calculateTotalTimeMeeting,
  convertTo12HourFormatMeeting,
} from "../GetMeeting/Helpers/functionHelper";
import { updateMeetingStatus } from "../GetMeeting/Helpers/apiHelper";
import SubscriberCard from "./components/SubscriberCard";
import { useDestinations } from "../../../../context/DestinationsContext";
import { Editor } from "@tinymce/tinymce-react";
import MeetingDiscussion from "./components/MeetingDiscussion";

const Invite = () => {
  const APIKEY = process.env.REACT_APP_TINYMCE_API;

  const location = useLocation();
  const navigate = useNavigate();
  const { getUserMeetingCount } = useDestinations();
  //I have a state in useMeeting context that will check wheather i have to call an api or not... if the callApi is true then call then i pass a parameter in the getMeetingById which is in CounterContext if callApi state is true then pass the parameter otherwise i have a button in Invite component and in that button function i explicitly set the callAPi to false when i am starting a meeting first time in that case i don't pass that parameter in getMeetingById API....
  const { setStatus, setOffset, setCallApi, setFromTektime } = useMeetings();
  const getTimezoneSymbol = (timezone) => timezoneSymbols[timezone] || timezone;
  const {
    handleShow,
    open,
    setOpen,
    setMeeting: setMeetingContext,
    setIsDuplicate,
    setIsUpdated,
    setCheckId,
    setAddParticipant,
    setChangePrivacy,
    setChangeContext,
    setChangeOptions,
    call,
    setFormState,
  } = useFormContext();

  const { id } = useParams();
  const [t] = useTranslation("global");
  const [activeTab, setActiveTab] = useState("casting");
  const [meeting, setMeeting] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { steps, updateSteps } = useSteps();
  const [showModal, setShowModal] = useState(false);
  const [showFileModal, setShowFileModal] = useState(false);
  const [estimateTime, setEstimateTime] = useState(null);
  const [estimateDate, setEstimateDate] = useState(null);
  const [isDrop, setIsDrop] = useState(false);
  const [isDropFile, setIsDropFile] = useState(false);
  const [view, setView] = useState("list");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showPlayConfirmationModal, setShowPlayConfirmationModal] =
    useState(false);
  const [showConfirmationCancelModal, setShowConfirmationCancelModal] =
    useState(false);
  const [itemIdToDelete, setItemIdToDelete] = useState(null);
  const [open1, setOpen1] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const [showHostProfile, setShowHostProfile] = useState(false);
  const [showOrgProfile, setShowOrgProfile] = useState(false);
  const [isFileUploaded, setIsFileUploaded] = useState(false);
  const [loading, setLoading] = useState(false);

  const openModal = (file) => {
    setModalContent(file);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalContent(null);
  };

  const handleFileChange = (event) => {
    event.target.value = "";
  };

  //For Discussion

  const [meetingMessages, setMeetingMessages] = useState([]);
  const getMeetingMessages = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/meeting/${id}/messages`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      if (response?.status === 200) {
        const data = response?.data?.data;
        const sortedMessages = [...(data || [])].sort(
          (a, b) => new Date(a.created_at) - new Date(b.created_at)
        );
        setMeetingMessages(sortedMessages);
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  useEffect(() => {
    if (id && activeTab === "discussion") getMeetingMessages();
  }, [id, activeTab]);

  const refreshMessages = async () => {
    getMeetingMessages();
    getMeeting();
  };

  //For Steps
  const [meetingSteps, setMeetingSteps] = useState([]);

  const getMeetingSteps = async () => {
    const currentTime = new Date();
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const options = { timeZone: userTimeZone };
    const timeInUserZone = new Date(
      currentTime.toLocaleString("en-US", options)
    );

    const formattedTime = formatTime(timeInUserZone);
    const formattedDate = formatDate(timeInUserZone);
    const userId = parseInt(sessionStorage.getItem("user_id"));
    try {
      const response = await axios.get(
        `${API_BASE_URL}/meeting/${id}/steps?current_time=${formattedTime}&current_date=${formattedDate}&user_id=${userId}&timezone=${userTimeZone}`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      if (response?.status === 200) {
        const data = response?.data?.data;
     

       // Update meeting state to include steps
      setMeeting(prevMeeting => ({
        ...prevMeeting,
        estimate_time:data?.estimate_time,
        steps: data
      }));
        setMeetingSteps(data);
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  useEffect(() => {
    if (id && activeTab === "steps") {
      getMeetingSteps();
    }
  }, [id, activeTab]);

  const refreshSteps = async () => {
    getMeetingSteps();
    getMeeting();
  };
  //For Files
  const [meetingFiles, setMeetingFiles] = useState([]);

  const getMeetingFiles = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/meeting/${id}/files`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      });
      if (response?.status === 200) {
        const data = response?.data?.data;
        setMeetingFiles(data);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const refreshFiles = async () => {
    getMeetingFiles();
    getMeeting();
  };
  useEffect(() => {
    if (id && activeTab === "files") {
      getMeetingFiles();
    }
  }, [id, activeTab]);
  const getRefreshMeeting = async () => {
    // if (activeTab === "casting") {
      getMeeting();
    // } else if (activeTab === "steps") {
      getMeetingSteps();
    // }
  };

  const [count, setCount] = useState(null);
  // Main function
  const getMeeting = async () => {
    const currentTime = new Date();
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const options = { timeZone: userTimeZone };
    const timeInUserZone = new Date(
      currentTime.toLocaleString("en-US", options)
    );

    const formattedTime = formatTime(timeInUserZone);
    const formattedDate = formatDate(timeInUserZone);
    const userId = parseInt(sessionStorage.getItem("user_id"));

    setIsLoading(true);
    try {
      const response = await axios.get(`${API_BASE_URL}/meeting/${id}/casting`);

      if (response.status) {
        const data = response?.data?.data;
        setCount(response?.data);
        setStatus(data?.status);

        // const steps = data?.steps;
        // updateSteps(steps);

        setMeeting(data);
        // ✅ Redirect if status is "closed"
        if (data?.status === "closed") {
          navigate(`/present/invite/${id}`, { state: { from: "meeting" } });
          return; // stop further execution
        }

        const { formattedDate: estimateDate, formattedTime: estimateTime } =
          parseAndFormatDateTime(
            data?.estimate_time,
            data?.type,
            data?.timezone
          );
        setEstimateTime(estimateTime);
        setEstimateDate(estimateDate);
      }
    } catch (error) {
      console.log("error while fetching meeting data", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getMeeting();
    setOffset(0);
  }, [id]);

  useEffect(() => {
    getRefreshMeeting();
  }, [call]);

  const forNavigate = async () => {
    const currentTime = new Date();
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const options = { timeZone: userTimeZone };
    const timeInUserZone = new Date(
      currentTime.toLocaleString("en-US", options)
    );

    const formattedTime = formatTime(timeInUserZone);
    const formattedDate = formatDate(timeInUserZone);
    const userId = parseInt(sessionStorage.getItem("user_id"));

    try {
      const response = await axios.get(
        `${API_BASE_URL}/meeting/${id}/casting`
      );

      if (response.status) {
        const { data } = response;
        if (data?.data?.status === "closed") {
          navigate(`/present/invite/${id}`, { state: { from: "meeting" } });
        }
      }
    } catch (error) {
      console.log("error while fetching meeting data", error);
    }
  };
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (
        document.visibilityState === "visible" ||
        document.visibilityState === "hidden"
      ) {
        console.log("Page is visible!");
        forNavigate();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  //Call this API every 5 sec to update the time interval
  const callMeetingApiForTimeTaken = async () => {
    if (meeting?.status !== "in_progress") {
      return;
    }

    try {
      const currentTime = new Date();
      const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      const options = { timeZone: userTimeZone };
      const timeInUserZone = new Date(
        currentTime.toLocaleString("en-US", options)
      );

      const formattedTime = formatTime(timeInUserZone);
      const formattedDate = formatDate(timeInUserZone);
      const userId = parseInt(sessionStorage.getItem("user_id"));

      const response = await axios.get(
        `${API_BASE_URL}/meeting/${id}/steps?current_time=${formattedTime}&current_date=${formattedDate}&user_id=${userId}&timezone=${userTimeZone}`
      );

      if (response.status) {
               const data = response?.data?.data;
               const meetingData = response?.data
        setMeetingSteps(data);
          setMeeting(prevMeeting => ({
        ...prevMeeting,
        estimate_time:meetingData?.meeting_estimate_time,
        steps: data
      }));

        const { formattedDate: estimateDate, formattedTime: estimateTime } =
          parseAndFormatDateTime(
            meetingData?.meeting_estimate_time,
            meeting?.type,
            meeting?.timezone
          );
        setEstimateTime(estimateTime);
        setEstimateDate(estimateDate);
      }
    } catch (error) {
      console.log("error while fetching meeting data", error);
    }
  };

  useEffect(() => {
    if (meeting?.status === "in_progress") {
      const intervalId = setInterval(callMeetingApiForTimeTaken, 30000); // 30 seconds
      return () => clearInterval(intervalId);
    }
  }, [meeting, id]);

  //WITH TIMEZONE CONVERSION
  const formattedDate = convertDateToUserTimezone(
    meeting?.date,
    meeting?.start_time,
    meeting?.timezone
  );

  const startTime = meeting?.start_time;
  const formattedTime = new Date(`1970-01-01T${startTime}`).toLocaleTimeString(
    "en-US",
    { hour: "2-digit", minute: "2-digit", hour12: true }
  );

  const loggedInUserId =
    sessionStorage.getItem("user_id") || localStorage.getItem("user_id");

  const [visoModal, setVisioModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const handleConfirm = () => {
    setVisioModal(false);

    if (selectedItem) {
      setTimeout(() => {
        const newTab = window.open(
          selectedItem?.meet_link,
          "_blank",
          "noopener,noreferrer"
        );

        if (!newTab) {
          console.error("Popup blocked! The new tab could not be opened.");
        } else {
          newTab.focus(); // Bring the new tab to the front after 5 seconds
        }
      }, 5000); // 5-second delay
    }

    if (selectedItem?.status === "in_progress") {
      continueChangeStatusAndPlay(selectedItem);
    } else {
      continueHandlePlay(selectedItem);
    }
  };

  const handleClose = () => {
    setVisioModal(false);
    setSelectedItem(null);
    if (selectedItem && selectedItem?.status === "in_progress") {
      continueChangeStatusAndPlay(selectedItem);
    } else {
      continueHandlePlay(selectedItem); // Continue the function after cancellation
    }
  };
  const updateCallApi = (value) => {
    setCallApi(value);
    sessionStorage.setItem("callApi", value);
  };
  const updateFromTektime = (value) => {
    setFromTektime(value);
    sessionStorage.setItem("fromTektime", value);
  };
  const [meetingToPlay, setMeetingToPlay] = useState(null);

  const handlePlay = async (item) => {
    const loggedInUserId = sessionStorage.getItem("user_id"); // Get the logged-in user's ID from session storage
    const scheduledDateTime = new Date(`${item.date}T${item.start_time}`);
    const currentDateTime = new Date();
    // Calculate the time difference in minutes
    const timeDifference = (currentDateTime - scheduledDateTime) / (1000 * 60);
    updateCallApi(false);
    updateFromTektime(true);

    const currentDate = moment().format("YYYY-MM-DD"); // Format to match the meeting date format
    if (item?.type === "Newsletter") {
      const meetingDate = moment(item.date).format("YYYY-MM-DD"); // Extract the meeting date in the same format

      if (meetingDate !== currentDate) {
        toast.error(t("errors.newletterplayMeeting"));
        setLoading(false);
        return;
      }
    } else if (item?.type !== "Task" && item.type !== "Strategy") {
      // Allow play only if the time difference is within ±60 minutes for active meetings
      if (
        !(timeDifference >= -60 && timeDifference <= 60) &&
        item.status === "active"
      ) {
        // toast.error(t("errors.playMeeting"));
        // setLoading(false);

        // return;
        // Show confirmation modal instead of toast error
        setMeetingToPlay(item);
        setShowPlayConfirmationModal(true);
        setLoading(false);
        return;
      }
    }
    // Check if the item type is "Newsletter"
    if (item.type !== "Newsletter") {
      const isGuide =
        meetingSteps?.some(
          (guide) => guide?.userPID === parseInt(loggedInUserId)
        ) ||
        // Check if all participants have user_id equal to meeting.user.id
        item?.user?.id === parseInt(loggedInUserId);

      if (!isGuide) {
        // console.log("User is not a guide. Cannot play the meeting.");
        toast.error(
          t("meeting.formState.you are not allowed to play the meeting")
        );
        setLoading(false);

        return; // Exit if the user is not a guide
      }
    }

    continueHandlePlay(item);
  };

  const continueHandlePlay = async (item) => {
    updateCallApi(false);
    updateFromTektime(true);
    setLoading(true);
    const scheduledDateTime = new Date(`${item.date}T${item.start_time}`);
    const currentDateTime = new Date();
    // Calculate the time difference in minutes
    const timeDifference = (currentDateTime - scheduledDateTime) / (1000 * 60);

    const currentDate = moment().format("YYYY-MM-DD"); // Format to match the meeting date format

    const endTime = new Date();
    const currentTime = new Date();

    // Get the user's time zone
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const localCurrentTime = currentTime.toLocaleString("en-GB", {
      timeZone: userTimeZone,
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
    const formattedCurrentDate = currentDateTime.toISOString().split("T")[0];

    const minOrderNo = Math.min(...meetingSteps.map((step) => step.order_no));

    // Find the first step (order_no 1)
    const firstStep = meetingSteps.find((step) => step.order_no === minOrderNo);
    const firstParticipant = firstStep?.assigned_to;

    // Format date and time in user's timezone
    const stepTimeFormatted = moment().tz(userTimeZone).format("hh:mm:ss A"); // "05:27:40 PM"
    const startDateFormatted = moment().tz(userTimeZone).format("YYYY-MM-DD"); // "2025-04-30"

    const updatedSteps = meetingSteps?.map((step) => {
      if (step.id === firstStep.id) {
        // The actual step that's being played
        return {
          ...step,
          status: "in_progress",
          step_status: "in_progress",
          current_time: localCurrentTime,
          current_date: formattedCurrentDate,
          step_time: stepTimeFormatted,
          start_date: startDateFormatted,
        };
      } else if (
        step.order_no === minOrderNo &&
        step.assigned_to === firstParticipant
      ) {
        // Same order_no and same participant as first step → Todo
        return {
          ...step,
          step_status: "todo",
          status: "todo",
        };
      } else if (
        step.order_no === minOrderNo &&
        step.assigned_to !== firstParticipant
      ) {
        // Same order_no but different participant → in_progress
        return {
          ...step,
          step_status: "in_progress",
          status: "in_progress",
          current_time: localCurrentTime,
          current_date: formattedCurrentDate,
          step_time: stepTimeFormatted,
          start_date: startDateFormatted,
        };
      }
      return step;
    });

    const payload = {
      ...item,
      steps: updatedSteps,
      starts_at: localCurrentTime,
      current_date: currentDateTime,
      status: "in_progress",
      _method: "put",
      moment_privacy_teams:
        item?.moment_privacy === "team" &&
        item?.moment_privacy_teams?.length &&
        typeof item?.moment_privacy_teams[0] === "object"
          ? item?.moment_privacy_teams.map((team) => team.id)
          : item?.moment_privacy_teams || [], // Send as-is if IDs are already present
    };

    try {
      const response = await axios.post(
        `${API_BASE_URL}/meetings/${item.id}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      if (response.status) {
        if (item?.type === "Task" || item?.type === "Strategy") {
          markTodoMeeting(item?.id);
          getMeeting();
        }
        // navigate(`/play/${item.id}`);

        window.open(`/destination/${item?.unique_id}/${item?.id}`, "_blank");
        getMeeting();
        getMeetingSteps()
        setLoading(false);

        // navigate(`/destínation/${item?.unique_id}/${item?.id}`);
      }
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  };

  // Add this confirmation handler
  const handleConfirmPlay = () => {
    if (meetingToPlay) {
      continueHandlePlay(meetingToPlay);
    }
    setShowPlayConfirmationModal(false);
  };
  const changeStatusAndPlay = async (item) => {
    const loggedInUserId = sessionStorage.getItem("user_id"); // Get the logged-in user's ID from session storage
    updateCallApi(true);
    updateFromTektime(true);

    // Check if the item type is "Newsletter"
    if (item.type !== "Newsletter") {
      // Check if the logged-in user is in the guides array

      const isGuide =
        meetingSteps?.some(
          (guide) => guide?.userPID === parseInt(loggedInUserId)
        ) ||
        // Check if all participants have user_id equal to meeting.user.id
        item?.user?.id === parseInt(loggedInUserId);
      if (!isGuide) {
        // console.log("User is not a guide. Cannot play the meeting.");
        toast.error(
          t("meeting.formState.you are not allowed to play the meeting")
        );
        setLoading(false);
        return; // Exit if the user is not a guide
      }
    }

    continueChangeStatusAndPlay(item);
  };
  const continueChangeStatusAndPlay = async (item) => {
    setLoading(true);

    window.open(`/destination/${item?.unique_id}/${item?.id}`, "_blank");

    setLoading(false);
  };

  const changeStatusAndRestart = async (item) => {
    const loggedInUserId = sessionStorage.getItem("user_id"); // Get the logged-in user's ID from session storage
    updateCallApi(true);
    updateFromTektime(true);

    // Check if the item type is "Newsletter"
    if (item.type !== "Newsletter") {
      // Check if the logged-in user is in the guides array

      const isGuide =
        meetingSteps?.some(
          (guide) => guide?.userPID === parseInt(loggedInUserId)
        ) ||
        // Check if all participants have user_id equal to meeting.user.id
        item?.user?.id === parseInt(loggedInUserId);
      if (!isGuide) {
        // console.log("User is not a guide. Cannot play the meeting.");
        toast.error(
          t("meeting.formState.you are not allowed to play the meeting")
        );
        setLoading(false);
        return; // Exit if the user is not a guide
      }
    }

    continueChangeStatusAndRestart(item);
  };

  const continueChangeStatusAndRestart = async (item) => {
    setLoading(true);
    try {
      const currentTime = new Date();
      const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      const options = { timeZone: userTimeZone };
      const timeInUserZone = new Date(
        currentTime.toLocaleString("en-US", options)
      );

      const formattedTime = formatTime(timeInUserZone);
      const formattedDate = formatDate(timeInUserZone);
      const response = await axios.get(
        `${API_BASE_URL}/play-to-finish-meeting/${item?.id}?current_time=${formattedTime}&current_date=${formattedDate}&pause_current_time=${formattedTime}&pause_current_date=${formattedDate}`
      );
      if (response?.status) {
        getMeeting();
        window.open(`/destination/${item?.unique_id}/${item?.id}`, "_blank");
      }
    } catch (error) {
      console.error("Error updating status:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleClick = (meeting) => {
    window.open(`/destination/${meeting?.unique_id}/${meeting?.id}`, "_blank");
  };

  const changeTodoStatusAndRestart = async (item) => {
    const loggedInUserId = sessionStorage.getItem("user_id"); // Get the logged-in user's ID from session storage
    updateCallApi(true);
    updateFromTektime(true);

    // Check if the item type is "Newsletter"
    if (item.type !== "Newsletter") {
      // Check if the logged-in user is in the guides array

      const isGuide =
        meetingSteps?.some(
          (guide) => guide?.userPID === parseInt(loggedInUserId)
        ) ||
        // Check if all participants have user_id equal to meeting.user.id
        item?.user?.id === parseInt(loggedInUserId);
      if (!isGuide) {
        // console.log("User is not a guide. Cannot play the meeting.");
        toast.error(
          t("meeting.formState.you are not allowed to play the meeting")
        );
        setLoading(false);
        return; // Exit if the user is not a guide
      }
    }

    continueChangeTodoStatusAndRestart(item);
  };

  const continueChangeTodoStatusAndRestart = async (item) => {
    setLoading(true);
    try {
      const currentTime = new Date();
      const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      const options = { timeZone: userTimeZone };
      const timeInUserZone = new Date(
        currentTime.toLocaleString("en-US", options)
      );

      const formattedTime = formatTime(timeInUserZone);
      const formattedDate = formatDate(timeInUserZone);
      const response = await axios.get(
        `${API_BASE_URL}/play-todo-meeting/${item?.id}?current_time=${formattedTime}&current_date=${formattedDate}&pause_current_time=${formattedTime}&pause_current_date=${formattedDate}`
      );
      if (response?.status) {
        getMeeting();
        window.open(`/destination/${item?.unique_id}/${item?.id}`, "_blank");
      }
    } catch (error) {
      console.error("Error updating status:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleEdit = (item) => {
    setCheckId(item.id);
    // setFormState(item);

     // Update formState while preserving any existing state
  setFormState(prev => ({
    ...prev,       // Spread existing state
    ...item,       // Spread the new item properties
    steps: meetingSteps || prev.steps  // Handle steps specifically if needed
  }));
    setIsUpdated(true);
    handleShow();
     // Update formState while preserving any existing state
  setMeetingContext(prev => ({
    ...prev,       // Spread existing state
    ...item,       // Spread the new item properties
    steps: meetingSteps || prev.steps  // Handle steps specifically if needed
  }));
    // setMeetingContext(item);
  };

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(`${API_BASE_URL}/meetings/${id}`, {
        headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` },
      });

      // Check for successful deletion (assuming HTTP status 200)
      if (response.status === 200) {
        toast.success("Réunion supprimée avec succès");
        navigate("/meeting");
      } else {
        // Handle other status codes (e.g., 4xx, 5xx) appropriately
        throw new Error("Échec de la suppression de la réunion");
      }
    } catch (error) {
      // Improve error handling, provide informative messages
      toast.error(t(error.message));
      // getUserMeetingCount();
    } finally {
      setFormState({});
    }
  };
  const handleDeleteClick = (e, id) => {
    e.stopPropagation();
    setItemIdToDelete(id);
    setShowConfirmationModal(true);
  };

  const confirmDelete = (e) => {
    e.stopPropagation();
    setShowConfirmationModal(false);
    handleDelete(itemIdToDelete);
  };
  const review = (data) => {
    navigate(`/view/${data.id}`, { state: data });
  };

  const handleToggle = () => {
    setView(view === "list" ? "graph" : "list");
    setOpen1(!open1);
  };

  const [newId, setNewId] = useState(null);
  const handleCloseModal = () => {
    setShowModal(false);
    setShowFileModal(false);
  };

  const formattedEndDateInHours = calculateEndDate(steps, meeting?.date);

  const guideEmails = new Set(meeting?.guides?.map((guide) => guide.email));

  const handleAddParticipant = (item) => {
    setCheckId(item?.id);
    setAddParticipant(true);
    setMeeting(item);
    handleShow();
  };
  const handleChangePrivacy = (item) => {
    setCheckId(item?.id);
    setFormState(item);
    setChangePrivacy(true);
    setMeeting(item);
    handleShow();
  };
  const handleChangeContext = (item) => {
    setCheckId(item?.id);
    setFormState(item);
    setChangeOptions(false);
    setChangeContext(true);
    setMeeting(item);
    handleShow();
  };
  const handleChangeOptions = (item) => {
    setCheckId(item?.id);
    setFormState(item);
    setChangeContext(false);
    setChangeOptions(true);

    setMeeting(item);
    handleShow();
  };

  const totalTime = calculateTotalTimeMeeting(meeting, t);

  const handleShow1 = () => {
    setShowProfile(true);
  };
  const hideShow = () => {
    setShowProfile(false);
  };

  const handleOrgShow = () => {
    setShowOrgProfile(true);
  };
  const hideOrgShow = () => {
    setShowOrgProfile(false);
  };
  const handleHostShow = () => {
    setShowHostProfile(true);
  };
  const hideHostShow = () => {
    setShowHostProfile(false);
  };

  const [isCloseMomentModalOpen, setIsCloseMomentModalOpen] = useState(false);
  const [closeMomentDateTime, setCloseMomentDateTime] = useState("");
  const [isConfirmCloseMomentOpen, setIsConfirmCloseMomentOpen] =
    useState(false);

  // Updated Confirm Handler
  const handleCloseMoment = async () => {
    let meetingClosedDate = closeMomentDateTime.split("T")[0]; // Get the date part from datetime input
    let meetingClosedTime = closeMomentDateTime.split("T")[1]; // Get the time part from datetime input

    // Ensure the time format is hh:mm:ss (if seconds are missing)
    if (meetingClosedTime && meetingClosedTime.length === 5) {
      meetingClosedTime = `${meetingClosedTime}:00`; // Append seconds (set to 00)
    }
    const data = {
      meeting_id: parseInt(id),
      meeting_closed_date: meetingClosedDate,
      meeting_closed_time: meetingClosedTime,
      starts_at: meeting?.starts_at || meeting?.start_time,
    };

    try {
      const response = await axios.post(
        `${API_BASE_URL}/close-meeting-manually`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );

      if (response.status) {
        toast.success(
          `Clôture: ${t(`types.${meeting?.type}`)} - ${meeting?.title}`
        );

        setIsCloseMomentModalOpen(false);
        setIsConfirmCloseMomentOpen(false);
        navigate(`/present/invite/${id}`, { state: { from: "meeting" } });
      }
    } catch (error) {
      console.error("Error closing moment:", error);
      toast.error("Something went wrong.");
    }
  };

  const editorRef = useRef(null);
  // const [content, setContent] = useState("");

  const handleEditorChange = (content) => {
    // setContent(content);
    setEditValue(content);
  };

  const uploadToCloudinary = async (blobInfo) => {
    return new Promise(async (resolve, reject) => {
      try {
        const formData = new FormData();
        formData.append("file", blobInfo.blob(), blobInfo.filename());
        formData.append("upload_preset", "chat-application"); // Replace with your upload preset
        formData.append("cloud_name", "drrk2kqvy"); // Replace with your cloud name

        const response = await fetch(
          `https://api.cloudinary.com/v1_1/drrk2kqvy/image/upload`,
          {
            method: "POST",
            body: formData,
          }
        );

        if (!response.ok) {
          throw new Error("Upload failed");
        }

        const data = await response.json();
        resolve(data.secure_url); // Return the secure URL from Cloudinary
      } catch (error) {
        console.error("Upload error:", error);
        reject("Image upload failed: " + error.message);
      }
    });
  };

  const [editingField, setEditingField] = useState(null);
  const [editValue, setEditValue] = useState("");

  const handleEditTitle = (meeting) => {
    setEditingField("title");
    setEditValue(meeting.title);
  };

  const handleEditDescription = (meeting) => {
    setEditingField("description");
    setEditValue(meeting.description);
    // setContent(meeting.description);
  };

  const handleSaveEdit = async () => {
    try {
      const token = sessionStorage.getItem("token");

      // Construct the payload with all meeting data, only updating the edited field
      const updatedMeeting = {
        ...meeting, // keep all other fields
        [editingField]: editValue, // only update the edited field
        _method: "put",
      };

      const response = await axios.post(
        `${API_BASE_URL}/meetings/${meeting.id}`,
        updatedMeeting,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.status === 200) {
        setEditingField(null);
        await getMeeting();
        toast.success(t("Updated successfully"));
      }
    } catch (error) {
      toast.error("Failed to update");
    }
  };

  return (
    <>
      {isLoading ? (
        <Spinner
          animation="border"
          role="status"
          className="center-spinner"
        ></Spinner>
      ) : (
        <div>
          <div
            className="invite w-100"
            style={{
              position: "static",
              backgroundColor: "white",
              padding: "10px 15px",
            }}
          >
            <div className="row child-1">
              <div className="col-md-6 w-100">
                <>
                  <div className="title mb-1">
                    <Link to={`/meeting`}>Agenda</Link>
                    <span> / </span>

                    <Link
                      to={{
                        pathname: `/invitiesToMeeting/${meeting?.destination_id}`,
                      }}
                    >
                      {meeting?.objective}
                    </Link>
                  </div>
                  <div className="invite-header">
                    <div
                      style={{
                        marginTop: 0,
                        width: "80%",
                      }}
                    >
                      <h5 className="content-heading-title w-100 d-flex align-items-center">
                        {meeting?.title}
                        {/* Edit icon for title */}
                        <span
                          className="ms-2 cursor-pointer"
                          style={{ cursor: "pointer" }}
                          onClick={() => handleEditTitle(meeting)}
                        >
                          <RiEditBoxLine size={20} />
                        </span>

                        {meeting?.status === "closed" ? (
                          <span className="mx-2 badge inprogrss">
                            {t("badge.finished")}
                          </span>
                        ) : meeting?.status === "in_progress" ? (
                          <>
                            <span
                              className={`${
                                meetingSteps?.some(
                                  (item) =>
                                    item?.step_status === "in_progress" &&
                                    convertTimeTakenToSeconds(
                                      item?.time_taken
                                    ) >
                                      convertCount2ToSeconds(
                                        item?.count2,
                                        item?.time_unit
                                      )
                                )
                                  ? "status-badge-red-invite"
                                  : "status-badge-inprogress-invite"
                              } mx-2 badge`}
                            >
                              {t("badge.inprogress")}
                            </span>
                          </>
                        ) : meeting?.status === "active" ? (
                          <span
                            style={{
                              verticalAlign: "text-bottom",
                            }}
                          >
                            <span
                              className={`badge ms-2 ${
                                moment().isAfter(
                                  moment(
                                    `${meeting?.date} ${meeting?.start_time}`,
                                    "YYYY-MM-DD HH:mm"
                                  )
                                )
                                  ? "late"
                                  : "future"
                              }`}
                              style={{ padding: "3px 8px 3px 8px" }}
                            >
                              {moment().isAfter(
                                moment(
                                  `${meeting?.date} ${meeting?.start_time}`,
                                  "YYYY-MM-DD HH:mm"
                                )
                              )
                                ? t("badge.late")
                                : t("badge.future")}
                            </span>
                          </span>
                        ) : meeting?.status === "to_finish" ? (
                          <span className="mx-2 badge status-badge-finish">
                            {t("badge.finish")}
                          </span>
                        ) : meeting?.status === "todo" ? (
                          <span className="mx-2 badge status-badge-green">
                            {t("badge.Todo")}
                          </span>
                        ) : (
                          <span className="mx-2 badge inprogrss">
                            {t("badge.finished")}
                          </span>
                        )}
                      </h5>
                    </div>
                    {/* Rejoindre la réunion */}
                    <div className="play-btn-container">
                      {parseInt(meeting?.user?.id) ===
                        parseInt(sessionStorage.getItem("user_id")) && (
                        <>
                          {/* Button */}

                          {meeting?.status === "in_progress" ? (
                            <>
                              {loading ? (
                                <button
                                  className={`btn play-btn`}
                                  style={{ padding: "13px 72px" }}
                                >
                                  <Spinner
                                    as="span"
                                    variant="light"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                    animation="border"
                                  />
                                </button>
                              ) : (
                                <Button
                                  className="btn play-btn"
                                  // onClick={() => handlePlay(meeting)}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    if (meeting.status === "active") {
                                      handlePlay(meeting);
                                    } else if (
                                      meeting?.status === "to_finish"
                                    ) {
                                      // changeStatusAndRestart(meeting);
                                      handleClick(meeting);
                                    } else if (meeting?.status === "todo") {
                                      changeTodoStatusAndRestart(meeting);
                                    } else {
                                      changeStatusAndPlay(meeting);
                                    }
                                  }}
                                  disabled={loading}
                                >
                                  {`${t("continue moment")}: ${
                                    meeting?.type === "Google Agenda Event"
                                      ? t("Join the meeting")
                                      : meeting?.solution
                                      ? meeting?.solution?.title
                                      : meeting?.type === "Prise de contact"
                                      ? "Prise de contact"
                                      : t(`types.${meeting?.type}`)
                                  }`}

                                  <FaArrowRight
                                    size={12}
                                    style={{
                                      marginLeft: ".5rem",
                                      fontWeight: 700,
                                    }}
                                  />
                                </Button>
                              )}
                            </>
                          ) : meeting?.status === "closed" ? (
                            <>
                              <Button
                                className="btn play-btn"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  updateCallApi(false);
                                  updateFromTektime(false);

                                  const currentURL = `/destination/${meeting?.unique_id}/${meeting?.id}`;
                                  copy(currentURL);
                                  openLinkInNewTab(currentURL);
                                }}
                                // disabled={transcriptLoading || summaryLoading}
                              >
                                {t("presentation.generateLink")}

                                <FaArrowRight
                                  size={12}
                                  style={{
                                    marginLeft: ".5rem",
                                    fontWeight: 700,
                                  }}
                                />
                              </Button>
                            </>
                          ) : meeting?.status === "to_finish" ||
                            meeting?.status === "todo" ? (
                            <>
                              {loading ? (
                                <button
                                  className={`btn play-btn`}
                                  style={{ padding: "13px 72px" }}

                                  // style={{ background: "#0d6efd" }}
                                >
                                  <Spinner
                                    as="span"
                                    variant="light"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                    animation="border"
                                  />
                                </button>
                              ) : (
                                <Button
                                  className="btn play-btn"
                                  // onClick={() => handlePlay(meeting)}
                                  onClick={
                                    meeting.status === "active"
                                      ? (e) => {
                                          e.stopPropagation();
                                          handlePlay(meeting);
                                        }
                                      : meeting?.status === "to_finish"
                                      ? (e) => {
                                          e.stopPropagation();
                                          // changeStatusAndRestart(meeting);
                                          handleClick(meeting);
                                        }
                                      : meeting?.status === "todo"
                                      ? (e) => {
                                          e.stopPropagation();
                                          changeTodoStatusAndRestart(meeting);
                                        }
                                      : (e) => {
                                          e.stopPropagation();
                                          changeStatusAndPlay(meeting);
                                        }
                                  }
                                  disabled={loading}
                                >
                                  {/* {t("startMoment")} */}
                                  {meeting?.type === "Google Agenda Event"
                                    ? t("Join the meeting")
                                    : `${t("follow")}: ${
                                        meeting?.solution
                                          ? meeting?.solution?.title
                                          : meeting?.type === "Prise de contact"
                                          ? "Prise de contact"
                                          : t(`types.${meeting?.type}`)
                                      }`}

                                  <FaArrowRight
                                    size={12}
                                    style={{
                                      marginLeft: ".5rem",
                                      fontWeight: 700,
                                    }}
                                  />
                                </Button>
                              )}
                            </>
                          ) : (
                            <>
                              {loading ? (
                                <button
                                  className={`btn play-btn`}
                                  style={{ padding: "13px 72px" }}

                                  // style={{ background: "#0d6efd" }}
                                >
                                  <Spinner
                                    as="span"
                                    variant="light"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                    animation="border"
                                  />
                                </button>
                              ) : (
                                <Button
                                  className="btn play-btn"
                                  // onClick={() => handlePlay(meeting)}
                                  onClick={
                                    meeting.status === "active"
                                      ? (e) => {
                                          e.stopPropagation();
                                          handlePlay(meeting);
                                        }
                                      : meeting?.status === "to_finish"
                                      ? (e) => {
                                          e.stopPropagation();
                                          changeStatusAndRestart(meeting);
                                        }
                                      : meeting?.status === "todo"
                                      ? (e) => {
                                          e.stopPropagation();
                                          changeTodoStatusAndRestart(meeting);
                                        }
                                      : (e) => {
                                          e.stopPropagation();
                                          changeStatusAndPlay(meeting);
                                        }
                                  }
                                  disabled={loading}
                                >
                                  {/* {t("startMoment")} */}
                                  {meeting?.type === "Google Agenda Event"
                                    ? t("Join the meeting")
                                    : `${t("startMoment")}: ${
                                        meeting?.solution
                                          ? meeting?.solution?.title
                                          : meeting?.type === "Prise de contact"
                                          ? "Prise de contact"
                                          : t(`types.${meeting?.type}`)
                                      }`}

                                  <FaArrowRight
                                    size={12}
                                    style={{
                                      marginLeft: ".5rem",
                                      fontWeight: 700,
                                    }}
                                  />
                                </Button>
                              )}
                            </>
                          )}
                        </>
                      )}

                      {/* Dropdown List */}
                      <Dropdown className="dropdown">
                        {meeting?.user?.id === parseInt(loggedInUserId) && (
                          <Dropdown.Toggle
                            variant="success"
                            id="dropdown-basic"
                          >
                            <BiDotsVerticalRounded
                              color="black"
                              size={"25px"}
                            />
                          </Dropdown.Toggle>
                        )}

                        {parseInt(meeting?.user?.id) ===
                        parseInt(loggedInUserId) ? (
                          <Dropdown.Menu>
                            {meeting?.status !== "in_progress" && (
                              <>
                                {meeting?.type === "Google Agenda Event" &&
                                meeting?.user?.email !==
                                  meeting?.event_creator?.email ? null : (
                                  <Dropdown.Item
                                    onClick={(e) => {
                                      handleEdit(meeting);
                                    }}
                                  >
                                    <RiEditBoxLine size={"20px"} /> &nbsp;
                                    {t("dropdown.To modify")}
                                  </Dropdown.Item>
                                )}
                              </>
                            )}
                            {meeting?.status === "in_progress" && (
                              <Dropdown.Item
                                onClick={(e) => {
                                  handleChangePrivacy(meeting);
                                }}
                              >
                                <RiEditBoxLine size={"20px"} /> &nbsp;
                                {t("dropdown.change Privacy")}
                              </Dropdown.Item>
                            )}
                            <Dropdown.Item
                              onClick={(e) => handleChangeContext(meeting)}
                            >
                              <RiEditBoxLine size={"18px"} /> &nbsp;{" "}
                              {t("dropdown.change Context")}
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={(e) => handleChangeOptions(meeting)}
                            >
                              <RiEditBoxLine size={"18px"} /> &nbsp;{" "}
                              {t("dropdown.change Options")}
                            </Dropdown.Item>

                            <Dropdown.Item
                              onClick={(e) => {
                                e.stopPropagation();
                                handleCopy(
                                  setFormState,
                                  meeting,
                                  t,
                                  handleShow,
                                  setMeetingContext,
                                  setCheckId,
                                  setIsDuplicate,
                                  setMeeting,
                                  setIsLoading,
                                  setStatus,
                                  updateSteps,
                                  meetingSteps
                                );
                              }}
                            >
                              <IoCopyOutline size={"18px"} /> &nbsp;
                              {t("dropdown.Duplicate")}
                            </Dropdown.Item>

                            {meeting?.status === "active" && (
                              <Dropdown.Item
                                onClick={(e) => {
                                  e.stopPropagation();
                                  updateCallApi(true);
                                  updateFromTektime(false);

                                  let currentURL = `/destination/${meeting?.unique_id}/${meeting?.id}`;
                                  copy(currentURL);
                                  openLinkInNewTab(currentURL);
                                }}
                              >
                                <LuLink size={"20px"} /> &nbsp;
                                {t("dropdown.invitation")}
                              </Dropdown.Item>
                            )}
                            <Dropdown.Item
                              onClick={() => setIsCloseMomentModalOpen(true)}
                            >
                              <FaRegCheckSquare size={"18px"} /> &nbsp;
                              {t("dropdown.CloseManually")}:{" "}
                              {meeting?.solution
                                ? meeting?.solution?.title
                                : meeting?.type === "Google Agenda Event"
                                ? "Google Agenda Event"
                                : meeting?.type === "Prise de contact"
                                ? "Prise de contact"
                                : t(`types.${meeting?.type}`)}
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={(e) => {
                                e.stopPropagation();
                                review(meeting);
                              }}
                            >
                              <AiOutlineEye size={"20px"} /> &nbsp;
                              {t("dropdown.Review the detail")}
                            </Dropdown.Item>

                            <hr
                              style={{
                                margin: "10px 0 0 0",
                                padding: "2px",
                              }}
                            />

                            {meeting?.status === "in_progress" ? (
                              <>
                                <Dropdown.Item
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setShowConfirmationCancelModal(true);

                                    // handleCancel(meeting.id);
                                  }}
                                >
                                  <ImCancelCircle size={"20px"} color="red" />
                                  &nbsp; {t("dropdown.Cancel")}
                                </Dropdown.Item>
                              </>
                            ) : (
                              <Dropdown.Item
                                onClick={(e) =>
                                  handleDeleteClick(e, meeting?.id)
                                }
                              >
                                <AiOutlineDelete size={"20px"} color="red" />
                                &nbsp; {t("dropdown.Delete")}
                              </Dropdown.Item>
                            )}
                          </Dropdown.Menu>
                        ) : (
                          // if user is not creator of the moment
                          <>
                            <Button
                              className="btn play-btn"
                              onClick={(e) => {
                                e.stopPropagation();
                                updateCallApi(true);
                                updateFromTektime(false);

                                const currentURL = `/destination/${meeting?.unique_id}/${meeting?.id}`;
                                copy(currentURL);
                                openLinkInNewTab(currentURL);
                              }}
                            >
                              <LuLink size={"20px"} /> &nbsp;
                              {t("dropdown.reviewinvitation")}
                              {/* {t("dropdown.Review the detail")} */}
                            </Button>
                          </>
                        )}
                      </Dropdown>
                    </div>
                  </div>
                  <div>
                    <div className="items">
                      <div className="type">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M8.33333 2.99984C8.33333 3.3665 8.20289 3.6805 7.942 3.94184C7.68111 4.20317 7.36711 4.33362 7 4.33317C6.85556 4.33317 6.72222 4.31362 6.6 4.2745C6.47778 4.23539 6.35556 4.17162 6.23333 4.08317C5.96667 4.17206 5.75289 4.33317 5.592 4.5665C5.43111 4.79984 5.35044 5.05539 5.35 5.33317H14L13.3333 9.99984H10.0667V8.6665H12.1833C12.2389 8.33317 12.2862 7.99984 12.3253 7.6665C12.3644 7.33317 12.4116 6.99984 12.4667 6.6665H3.53333C3.58889 6.99984 3.63622 7.33317 3.67533 7.6665C3.71444 7.99984 3.76156 8.33317 3.81667 8.6665H5.93333V9.99984H2.66667L2 5.33317H4C4 4.78873 4.15 4.29428 4.45 3.84984C4.75 3.40539 5.15556 3.07762 5.66667 2.8665C5.7 2.52206 5.84444 2.23606 6.1 2.0085C6.35556 1.78095 6.65556 1.66695 7 1.6665C7.36667 1.6665 7.68067 1.79717 7.942 2.0585C8.20333 2.31984 8.33378 2.63362 8.33333 2.99984ZM6.51667 12.6665H9.48333L9.86667 8.6665H6.13333L6.51667 12.6665ZM5.33333 13.9998L4.83333 8.79984C4.78889 8.41095 4.9 8.06939 5.16667 7.77517C5.43333 7.48095 5.76111 7.33362 6.15 7.33317H9.85C10.2389 7.33317 10.5667 7.4805 10.8333 7.77517C11.1 8.06984 11.2111 8.41139 11.1667 8.79984L10.6667 13.9998H5.33333Z"
                            fill="#8590A3"
                          />
                        </svg>
                        {/* <span className="time">{meeting?.type}</span> */}
                        <span className="time">
                          {meeting?.solution
                            ? meeting?.solution?.title
                            : meeting?.type === "Google Agenda Event"
                            ? "Google Agenda Event"
                            : meeting?.type === "Prise de contact"
                            ? "Prise de contact"
                            : t(`types.${meeting?.type}`)}
                        </span>
                      </div>
                   
                    </div>

                    <div className="d-flex align-items-center gap-2 content-body mt-3 mb-2 mt-lg-3">
                      <div className="d-flex align-items-center gap-2">
                        <img
                          src="/Assets/invite-date.svg"
                          height="28px"
                          width="28px"
                        />

                        {meeting?.type === "Action1" ||
                        meeting?.type === "Newsletter" ||
                        meeting?.type === "Strategy" ? (
                          <>
                            <span className="fw-bold formate-date">
                              {formattedDate}
                            </span>{" "}
                            -
                            <span className="fw-bold formate-date">
                              {estimateDate}
                            </span>
                          </>
                        ) : (
                          <>
                            <span className="fw-bold formate-date">
                              {formattedDate}
                              &nbsp; {t("at")}
                            </span>
                            <span className="fw-bold formate-date">
                              {/* {formattedTime} */}
                              {meeting?.status === "in_progress"
                                ? convertTo12HourFormatMeeting(
                                    meeting?.starts_at,
                                    meeting?.current_date,
                                    meeting?.timezone
                                  )
                                : convertTo12HourFormatMeeting(
                                    meeting?.start_time,
                                    meeting?.date,
                                    meeting?.timezone
                                  )}{" "}
                              -{" "}
                            </span>

                            <span className="fw-bold formate-date">
                              {estimateDate}
                              &nbsp; {t("at")}
                            </span>
                            <span className="fw-bold formate-date">
                              {estimateTime}
                            </span>
                          </>
                        )}
                        <span className="fw-bold">
                          {getTimezoneSymbol(localStorage.getItem("timezone"))}
                        </span>
                      </div>
                    </div>

                    {/* Location */}
                    <div>
                      {(meeting?.location && meeting?.location !== "None") ||
                      (meeting?.agenda && meeting?.agenda !== "None") ? (
                        <div className="d-flex gap-4 align-items-center mt-2 mb-2">
                          {meeting?.location &&
                            meeting?.location !== "None" && (
                              <p className="d-flex gap-2 justify-content-start ps-0 fw-bold align-items-center mb-0">
                                {meeting?.location === "Zoom" ? (
                                  <>
                                    <svg
                                      width="28px"
                                      height="28px"
                                      viewBox="0 0 32 32"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <g
                                        id="SVGRepo_bgCarrier"
                                        stroke-width="0"
                                      ></g>
                                      <g
                                        id="SVGRepo_tracerCarrier"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      ></g>
                                      <g id="SVGRepo_iconCarrier">
                                        {" "}
                                        <path
                                          d="M2 11.6C2 8.23969 2 6.55953 2.65396 5.27606C3.2292 4.14708 4.14708 3.2292 5.27606 2.65396C6.55953 2 8.23969 2 11.6 2H20.4C23.7603 2 25.4405 2 26.7239 2.65396C27.8529 3.2292 28.7708 4.14708 29.346 5.27606C30 6.55953 30 8.23969 30 11.6V20.4C30 23.7603 30 25.4405 29.346 26.7239C28.7708 27.8529 27.8529 28.7708 26.7239 29.346C25.4405 30 23.7603 30 20.4 30H11.6C8.23969 30 6.55953 30 5.27606 29.346C4.14708 28.7708 3.2292 27.8529 2.65396 26.7239C2 25.4405 2 23.7603 2 20.4V11.6Z"
                                          fill="#4087FC"
                                        ></path>{" "}
                                        <path
                                          d="M8.26667 10C7.56711 10 7 10.6396 7 11.4286V18.3571C7 20.369 8.44612 22 10.23 22L17.7333 21.9286C18.4329 21.9286 19 21.289 19 20.5V13.5C19 11.4881 17.2839 10 15.5 10L8.26667 10Z"
                                          fill="white"
                                        ></path>{" "}
                                        <path
                                          d="M20.7122 12.7276C20.2596 13.1752 20 13.8211 20 14.5V17.3993C20 18.0782 20.2596 18.7242 20.7122 19.1717L23.5288 21.6525C24.1019 22.2191 25 21.7601 25 20.9005V11.1352C25 10.2755 24.1019 9.81654 23.5288 10.3832L20.7122 12.7276Z"
                                          fill="white"
                                        ></path>{" "}
                                      </g>
                                    </svg>
                                    <span className="solutioncards option-text">
                                      {
                                        meeting?.user?.user_zoom_info
                                          ?.display_name
                                      }
                                    </span>
                                  </>
                                ) : meeting?.location === "Microsoft Teams" ? (
                                  <>
                                    <span>
                                      <svg
                                        width="28px"
                                        height="28px"
                                        viewBox="0 0 16 16"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                      >
                                        <g
                                          id="SVGRepo_bgCarrier"
                                          stroke-width="0"
                                        ></g>
                                        <g
                                          id="SVGRepo_tracerCarrier"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        ></g>
                                        <g id="SVGRepo_iconCarrier">
                                          <path
                                            fill="#5059C9"
                                            d="M10.765 6.875h3.616c.342 0 .619.276.619.617v3.288a2.272 2.272 0 01-2.274 2.27h-.01a2.272 2.272 0 01-2.274-2.27V7.199c0-.179.145-.323.323-.323zM13.21 6.225c.808 0 1.464-.655 1.464-1.462 0-.808-.656-1.463-1.465-1.463s-1.465.655-1.465 1.463c0 .807.656 1.462 1.465 1.462z"
                                          ></path>
                                          <path
                                            fill="#7B83EB"
                                            d="M8.651 6.225a2.114 2.114 0 002.117-2.112A2.114 2.114 0 008.65 2a2.114 2.114 0 00-2.116 2.112c0 1.167.947 2.113 2.116 2.113zM11.473 6.875h-5.97a.611.611 0 00-.596.625v3.75A3.669 3.669 0 008.488 15a3.669 3.669 0 003.582-3.75V7.5a.611.611 0 00-.597-.625z"
                                          ></path>
                                          <path
                                            fill="#000000"
                                            d="M8.814 6.875v5.255a.598.598 0 01-.596.595H5.193a3.951 3.951 0 01-.287-1.476V7.5a.61.61 0 01.597-.624h3.31z"
                                            opacity=".1"
                                          ></path>
                                          <path
                                            fill="#000000"
                                            d="M8.488 6.875v5.58a.6.6 0 01-.596.595H5.347a3.22 3.22 0 01-.267-.65 3.951 3.951 0 01-.172-1.15V7.498a.61.61 0 01.596-.624h2.985z"
                                            opacity=".2"
                                          ></path>
                                          <path
                                            fill="#000000"
                                            d="M8.488 6.875v4.93a.6.6 0 01-.596.595H5.08a3.951 3.951 0 01-.172-1.15V7.498a.61.61 0 01.596-.624h2.985z"
                                            opacity=".2"
                                          ></path>
                                          <path
                                            fill="#000000"
                                            d="M8.163 6.875v4.93a.6.6 0 01-.596.595H5.079a3.951 3.951 0 01-.172-1.15V7.498a.61.61 0 01.596-.624h2.66z"
                                            opacity=".2"
                                          ></path>
                                          <path
                                            fill="#000000"
                                            d="M8.814 5.195v1.024c-.055.003-.107.006-.163.006-.055 0-.107-.003-.163-.006A2.115 2.115 0 016.593 4.6h1.625a.598.598 0 01.596.594z"
                                            opacity=".1"
                                          ></path>
                                          <path
                                            fill="#000000"
                                            d="M8.488 5.52v.699a2.115 2.115 0 01-1.79-1.293h1.195a.598.598 0 01.595.594z"
                                            opacity=".2"
                                          ></path>
                                          <path
                                            fill="#000000"
                                            d="M8.488 5.52v.699a2.115 2.115 0 01-1.79-1.293h1.195a.598.598 0 01.595.594z"
                                            opacity=".2"
                                          ></path>
                                          <path
                                            fill="#000000"
                                            d="M8.163 5.52v.647a2.115 2.115 0 01-1.465-1.242h.87a.598.598 0 01.595.595z"
                                            opacity=".2"
                                          ></path>
                                          <path
                                            fill="url(#microsoft-teams-color-16__paint0_linear_2372_494)"
                                            d="M1.597 4.925h5.969c.33 0 .597.267.597.596v5.958a.596.596 0 01-.597.596h-5.97A.596.596 0 011 11.479V5.521c0-.33.267-.596.597-.596z"
                                          ></path>
                                          <path
                                            fill="#ffffff"
                                            d="M6.152 7.193H4.959v3.243h-.76V7.193H3.01v-.63h3.141v.63z"
                                          ></path>
                                          <defs>
                                            <linearGradient
                                              id="microsoft-teams-color-16__paint0_linear_2372_494"
                                              x1="2.244"
                                              x2="6.906"
                                              y1="4.46"
                                              y2="12.548"
                                              gradientUnits="userSpaceOnUse"
                                            >
                                              <stop stop-color="#5A62C3"></stop>
                                              <stop
                                                offset=".5"
                                                stop-color="#4D55BD"
                                              ></stop>
                                              <stop
                                                offset="1"
                                                stop-color="#3940AB"
                                              ></stop>
                                            </linearGradient>
                                          </defs>
                                        </g>
                                      </svg>
                                    </span>

                                    <span className="solutioncards option-text">
                                      {
                                        meeting?.user?.outlook_user_info
                                          ?.displayName
                                      }
                                    </span>
                                  </>
                                ) : (
                                  <>
                                    <span>
                                      <svg
                                        width="28px"
                                        height="28px"
                                        viewBox="0 0 32 32"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <g
                                          id="SVGRepo_bgCarrier"
                                          stroke-width="0"
                                        ></g>
                                        <g
                                          id="SVGRepo_tracerCarrier"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        ></g>
                                        <g id="SVGRepo_iconCarrier">
                                          {" "}
                                          <path
                                            d="M2 11.9556C2 8.47078 2 6.7284 2.67818 5.39739C3.27473 4.22661 4.22661 3.27473 5.39739 2.67818C6.7284 2 8.47078 2 11.9556 2H20.0444C23.5292 2 25.2716 2 26.6026 2.67818C27.7734 3.27473 28.7253 4.22661 29.3218 5.39739C30 6.7284 30 8.47078 30 11.9556V20.0444C30 23.5292 30 25.2716 29.3218 26.6026C28.7253 27.7734 27.7734 28.7253 26.6026 29.3218C25.2716 30 23.5292 30 20.0444 30H11.9556C8.47078 30 6.7284 30 5.39739 29.3218C4.22661 28.7253 3.27473 27.7734 2.67818 26.6026C2 25.2716 2 23.5292 2 20.0444V11.9556Z"
                                            fill="white"
                                          ></path>{" "}
                                          <path
                                            d="M5 23.5601C5 24.3557 5.64998 25.0001 6.45081 25.0001H6.47166C5.65857 25.0001 5 24.3557 5 23.5601Z"
                                            fill="#FBBC05"
                                          ></path>{" "}
                                          <path
                                            d="M17.4678 12.4V16.1596L22.5364 12.0712V8.43999C22.5364 7.6444 21.8864 7 21.0856 7H10.1045L10.0947 12.4H17.4678Z"
                                            fill="#FBBC05"
                                          ></path>{" "}
                                          <path
                                            d="M17.4671 19.9207H10.0818L10.0732 25.0003H21.085C21.887 25.0003 22.5358 24.3559 22.5358 23.5603V20.2819L17.4671 16.1611V19.9207Z"
                                            fill="#34A853"
                                          ></path>{" "}
                                          <path
                                            d="M10.1042 7L5 12.4H10.0956L10.1042 7Z"
                                            fill="#EA4335"
                                          ></path>{" "}
                                          <path
                                            d="M5 19.9204V23.56C5 24.3556 5.65857 25 6.47166 25H10.0736L10.0821 19.9204H5Z"
                                            fill="#1967D2"
                                          ></path>{" "}
                                          <path
                                            d="M10.0956 12.3999H5V19.9203H10.0821L10.0956 12.3999Z"
                                            fill="#4285F4"
                                          ></path>{" "}
                                          <path
                                            d="M26.9926 22.2796V9.9197C26.7068 8.27931 24.9077 10.1597 24.9077 10.1597L22.5371 12.0713V20.2804L25.9305 23.0392C27.1557 23.2 26.9926 22.2796 26.9926 22.2796Z"
                                            fill="#34A853"
                                          ></path>{" "}
                                          <path
                                            d="M17.4678 16.1594L22.5377 20.2814V12.0723L17.4678 16.1594Z"
                                            fill="#188038"
                                          ></path>{" "}
                                        </g>
                                      </svg>
                                    </span>
                                    <span className="solutioncards option-text">
                                      {meeting?.user?.google_full_name}
                                    </span>
                                  </>
                                )}
                              </p>
                            )}
                          {meeting?.agenda && meeting?.agenda !== "None" && (
                            <p className="d-flex gap-2 justify-content-start ps-0 fw-bold align-items-center mb-0">
                              {meeting?.agenda === "Zoom Agenda" ? (
                                <>
                                  <>
                                    <svg
                                      width="28px"
                                      height="28px"
                                      viewBox="0 0 32 32"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <g
                                        id="SVGRepo_bgCarrier"
                                        stroke-width="0"
                                      ></g>
                                      <g
                                        id="SVGRepo_tracerCarrier"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      ></g>
                                      <g id="SVGRepo_iconCarrier">
                                        {" "}
                                        <path
                                          d="M2 11.6C2 8.23969 2 6.55953 2.65396 5.27606C3.2292 4.14708 4.14708 3.2292 5.27606 2.65396C6.55953 2 8.23969 2 11.6 2H20.4C23.7603 2 25.4405 2 26.7239 2.65396C27.8529 3.2292 28.7708 4.14708 29.346 5.27606C30 6.55953 30 8.23969 30 11.6V20.4C30 23.7603 30 25.4405 29.346 26.7239C28.7708 27.8529 27.8529 28.7708 26.7239 29.346C25.4405 30 23.7603 30 20.4 30H11.6C8.23969 30 6.55953 30 5.27606 29.346C4.14708 28.7708 3.2292 27.8529 2.65396 26.7239C2 25.4405 2 23.7603 2 20.4V11.6Z"
                                          fill="#4087FC"
                                        ></path>{" "}
                                        <path
                                          d="M8.26667 10C7.56711 10 7 10.6396 7 11.4286V18.3571C7 20.369 8.44612 22 10.23 22L17.7333 21.9286C18.4329 21.9286 19 21.289 19 20.5V13.5C19 11.4881 17.2839 10 15.5 10L8.26667 10Z"
                                          fill="white"
                                        ></path>{" "}
                                        <path
                                          d="M20.7122 12.7276C20.2596 13.1752 20 13.8211 20 14.5V17.3993C20 18.0782 20.2596 18.7242 20.7122 19.1717L23.5288 21.6525C24.1019 22.2191 25 21.7601 25 20.9005V11.1352C25 10.2755 24.1019 9.81654 23.5288 10.3832L20.7122 12.7276Z"
                                          fill="white"
                                        ></path>{" "}
                                      </g>
                                    </svg>
                                    <span className="solutioncards option-text">
                                      {
                                        meeting?.user?.user_zoom_info
                                          ?.display_name
                                      }
                                    </span>
                                  </>
                                </>
                              ) : meeting?.agenda === "Outlook Agenda" ? (
                                <>
                                  <span>
                                    <svg
                                      width="28px"
                                      height="28px"
                                      viewBox="0 0 32 32"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <g
                                        id="SVGRepo_bgCarrier"
                                        stroke-width="0"
                                      ></g>
                                      <g
                                        id="SVGRepo_tracerCarrier"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      ></g>
                                      <g id="SVGRepo_iconCarrier">
                                        {" "}
                                        <rect
                                          x="10"
                                          y="2"
                                          width="20"
                                          height="28"
                                          rx="2"
                                          fill="#1066B5"
                                        ></rect>{" "}
                                        <rect
                                          x="10"
                                          y="2"
                                          width="20"
                                          height="28"
                                          rx="2"
                                          fill="url(#paint0_linear_87_7742)"
                                        ></rect>{" "}
                                        <rect
                                          x="10"
                                          y="5"
                                          width="10"
                                          height="10"
                                          fill="#32A9E7"
                                        ></rect>{" "}
                                        <rect
                                          x="10"
                                          y="15"
                                          width="10"
                                          height="10"
                                          fill="#167EB4"
                                        ></rect>{" "}
                                        <rect
                                          x="20"
                                          y="15"
                                          width="10"
                                          height="10"
                                          fill="#32A9E7"
                                        ></rect>{" "}
                                        <rect
                                          x="20"
                                          y="5"
                                          width="10"
                                          height="10"
                                          fill="#58D9FD"
                                        ></rect>{" "}
                                        <mask
                                          id="mask0_87_7742"
                                          style={{ maskType: "alpha" }}
                                          maskUnits="userSpaceOnUse"
                                          x="8"
                                          y="14"
                                          width="24"
                                          height="16"
                                        >
                                          {" "}
                                          <path
                                            d="M8 14H30C31.1046 14 32 14.8954 32 16V28C32 29.1046 31.1046 30 30 30H10C8.89543 30 8 29.1046 8 28V14Z"
                                            fill="url(#paint1_linear_87_7742)"
                                          ></path>{" "}
                                        </mask>{" "}
                                        <g mask="url(#mask0_87_7742)">
                                          {" "}
                                          <path
                                            d="M32 14V18H30V14H32Z"
                                            fill="#135298"
                                          ></path>{" "}
                                          <path
                                            d="M32 30V16L7 30H32Z"
                                            fill="url(#paint2_linear_87_7742)"
                                          ></path>{" "}
                                          <path
                                            d="M8 30V16L33 30H8Z"
                                            fill="url(#paint3_linear_87_7742)"
                                          ></path>{" "}
                                        </g>{" "}
                                        <path
                                          d="M8 12C8 10.3431 9.34315 9 11 9H17C18.6569 9 20 10.3431 20 12V24C20 25.6569 18.6569 27 17 27H8V12Z"
                                          fill="#000000"
                                          fill-opacity="0.3"
                                        ></path>{" "}
                                        <rect
                                          y="7"
                                          width="18"
                                          height="18"
                                          rx="2"
                                          fill="url(#paint4_linear_87_7742)"
                                        ></rect>{" "}
                                        <path
                                          d="M14 16.0693V15.903C14 13.0222 11.9272 11 9.01582 11C6.08861 11 4 13.036 4 15.9307V16.097C4 18.9778 6.07278 21 9 21C11.9114 21 14 18.964 14 16.0693ZM11.6424 16.097C11.6424 18.0083 10.5665 19.1579 9.01582 19.1579C7.46519 19.1579 6.37342 17.9806 6.37342 16.0693V15.903C6.37342 13.9917 7.44937 12.8421 9 12.8421C10.5348 12.8421 11.6424 14.0194 11.6424 15.9307V16.097Z"
                                          fill="white"
                                        ></path>{" "}
                                        <defs>
                                          {" "}
                                          <linearGradient
                                            id="paint0_linear_87_7742"
                                            x1="10"
                                            y1="16"
                                            x2="30"
                                            y2="16"
                                            gradientUnits="userSpaceOnUse"
                                          >
                                            {" "}
                                            <stop stop-color="#064484"></stop>{" "}
                                            <stop
                                              offset="1"
                                              stop-color="#0F65B5"
                                            ></stop>{" "}
                                          </linearGradient>{" "}
                                          <linearGradient
                                            id="paint1_linear_87_7742"
                                            x1="8"
                                            y1="26.7692"
                                            x2="32"
                                            y2="26.7692"
                                            gradientUnits="userSpaceOnUse"
                                          >
                                            {" "}
                                            <stop stop-color="#1B366F"></stop>{" "}
                                            <stop
                                              offset="1"
                                              stop-color="#2657B0"
                                            ></stop>{" "}
                                          </linearGradient>{" "}
                                          <linearGradient
                                            id="paint2_linear_87_7742"
                                            x1="32"
                                            y1="23"
                                            x2="8"
                                            y2="23"
                                            gradientUnits="userSpaceOnUse"
                                          >
                                            {" "}
                                            <stop stop-color="#44DCFD"></stop>{" "}
                                            <stop
                                              offset="0.453125"
                                              stop-color="#259ED0"
                                            ></stop>{" "}
                                          </linearGradient>{" "}
                                          <linearGradient
                                            id="paint3_linear_87_7742"
                                            x1="8"
                                            y1="23"
                                            x2="32"
                                            y2="23"
                                            gradientUnits="userSpaceOnUse"
                                          >
                                            {" "}
                                            <stop stop-color="#259ED0"></stop>{" "}
                                            <stop
                                              offset="1"
                                              stop-color="#44DCFD"
                                            ></stop>{" "}
                                          </linearGradient>{" "}
                                          <linearGradient
                                            id="paint4_linear_87_7742"
                                            x1="0"
                                            y1="16"
                                            x2="18"
                                            y2="16"
                                            gradientUnits="userSpaceOnUse"
                                          >
                                            {" "}
                                            <stop stop-color="#064484"></stop>{" "}
                                            <stop
                                              offset="1"
                                              stop-color="#0F65B5"
                                            ></stop>{" "}
                                          </linearGradient>{" "}
                                        </defs>{" "}
                                      </g>
                                    </svg>
                                  </span>
                                  <span className="solutioncards option-text">
                                    {meeting?.user?.outlook_user_info?.mail}
                                  </span>
                                </>
                              ) : (
                                <>
                                  <span>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      aria-label="Google Calendar"
                                      role="img"
                                      viewBox="0 0 512 512"
                                      width="28px"
                                      height="28px"
                                      fill="#000000"
                                    >
                                      <g
                                        id="SVGRepo_bgCarrier"
                                        stroke-width="0"
                                      ></g>
                                      <g
                                        id="SVGRepo_tracerCarrier"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      ></g>
                                      <g id="SVGRepo_iconCarrier">
                                        <rect
                                          width="512"
                                          height="512"
                                          rx="15%"
                                          fill="#ffffff"
                                        ></rect>
                                        <path
                                          d="M100 340h74V174H340v-74H137Q100 100 100 135"
                                          fill="#4285f4"
                                        ></path>
                                        <path
                                          d="M338 100v76h74v-41q0-35-35-35"
                                          fill="#1967d2"
                                        ></path>
                                        <path
                                          d="M338 174h74V338h-74"
                                          fill="#fbbc04"
                                        ></path>
                                        <path
                                          d="M100 338v39q0 35 35 35h41v-74"
                                          fill="#188038"
                                        ></path>
                                        <path
                                          d="M174 338H338v74H174"
                                          fill="#34a853"
                                        ></path>
                                        <path
                                          d="M338 412v-74h74"
                                          fill="#ea4335"
                                        ></path>
                                        <path
                                          d="M204 229a25 22 1 1 1 25 27h-9h9a25 22 1 1 1-25 27M270 231l27-19h4v-7V308"
                                          stroke="#4285f4"
                                          stroke-width="15"
                                          stroke-linejoin="bevel"
                                          fill="none"
                                        ></path>
                                      </g>
                                    </svg>
                                  </span>
                                  <span className="solutioncards option-text">
                                    {meeting?.user?.google_full_name}
                                  </span>
                                </>
                              )}
                            </p>
                          )}
                        </div>
                      ) : null}

                      <div className="ps-0">
                        {meeting?.address ? (
                          <p className="d-flex gap-2 align-items-center justify-content-start ps-0 ms-0 mt-2">
                            <FaLocationDot size={25} />
                            <span>{meeting?.address}</span>
                          </p>
                        ) : null}
                      </div>
                      {meeting?.room_details ? (
                        <div>
                          <p className="d-flex gap-2 mt-2 justify-content-start align-items-top ps-0">
                            <BsPersonWorkspace size={25} />
                            <p className="m-0">
                              {meeting?.room_details && meeting?.room_details}
                            </p>
                          </p>
                        </div>
                      ) : null}
                      {meeting?.phone ? ( // Check if the phone field exists
                        <div>
                          <p className="d-flex gap-2 align-items-center justify-content-start ps-0 mt-2">
                            <span>
                              <FaPhoneAlt size={25} />
                            </span>
                            <a
                              href={`tel:${meeting.phone}`}
                              className="text-decoration-none"
                            >
                              <span className="">{meeting.phone}</span>{" "}
                              {/* Display the phone number */}
                            </a>
                          </p>
                        </div>
                      ) : null}
                    </div>

                    {/* Options */}
                    <div className="row mt-2">
                      <div className="col-md-12 d-flex align-items-center gap-3">
                        {meeting?.prise_de_notes === "Automatic" && (
                          <>
                            <div>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="28"
                                height="28"
                                viewBox="0 0 28 28"
                                fill="none"
                              >
                                <g filter="url(#filter0_d_1_1154)">
                                  <circle
                                    cx="14"
                                    cy="12"
                                    r="10"
                                    stroke="url(#paint0_linear_1_1154)"
                                    strokeWidth="4"
                                  />
                                </g>
                                <defs>
                                  <filter
                                    id="filter0_d_1_1154"
                                    x="0"
                                    y="0"
                                    width="28"
                                    height="28"
                                    filterUnits="userSpaceOnUse"
                                    colorInterpolationFilters="sRGB"
                                  >
                                    <feFlood
                                      floodOpacity="0"
                                      result="BackgroundImageFix"
                                    />
                                    <feColorMatrix
                                      in="SourceAlpha"
                                      type="matrix"
                                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                      result="hardAlpha"
                                    />
                                    <feOffset dy="2" />
                                    <feGaussianBlur stdDeviation="1" />
                                    <feColorMatrix
                                      type="matrix"
                                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
                                    />
                                    <feBlend
                                      mode="normal"
                                      in2="BackgroundImageFix"
                                      result="effect1_dropShadow_1_1154"
                                    />
                                    <feBlend
                                      mode="normal"
                                      in="SourceGraphic"
                                      in2="effect1_dropShadow_1_1154"
                                      result="shape"
                                    />
                                  </filter>
                                  <linearGradient
                                    id="paint0_linear_1_1154"
                                    x1="14"
                                    y1="0"
                                    x2="20.375"
                                    y2="21.75"
                                    gradientUnits="userSpaceOnUse"
                                  >
                                    <stop stopColor="#B11FAB" />
                                    <stop offset="0.514" stopColor="#56E8F1" />
                                    <stop offset="1" stopColor="#2F47C1" />
                                  </linearGradient>
                                </defs>
                              </svg>
                              <span className="solutioncards option-text">
                                {t("meeting.formState.Automatic note taking")}
                              </span>
                            </div>
                          </>
                        )}
                        {meeting?.alarm === true && (
                          <>
                            <div>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="25"
                                height="24"
                                viewBox="0 0 25 24"
                                fill="none"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M12.5001 1.35999C12.2879 1.35999 12.0844 1.44427 11.9344 1.5943C11.7844 1.74433 11.7001 1.94781 11.7001 2.15999V5.63519C11.7001 5.84736 11.7844 6.05084 11.9344 6.20087C12.0844 6.3509 12.2879 6.43519 12.5001 6.43519C12.7122 6.43519 12.9157 6.3509 13.0658 6.20087C13.2158 6.05084 13.3001 5.84736 13.3001 5.63519V2.99519C15.3173 3.17457 17.2159 4.02613 18.6915 5.41333C20.167 6.80054 21.134 8.64304 21.4373 10.6454C21.7407 12.6478 21.363 14.694 20.3646 16.4561C19.3662 18.2181 17.8051 19.5939 15.9315 20.3628C14.058 21.1317 11.9805 21.2492 10.0321 20.6965C8.08379 20.1437 6.37749 18.9528 5.1868 17.3145C3.99611 15.6763 3.39001 13.6857 3.46567 11.6619C3.54134 9.63811 4.29438 7.69833 5.60407 6.15358C5.67546 6.07402 5.73018 5.98095 5.765 5.87989C5.79981 5.77882 5.81402 5.6718 5.80678 5.56514C5.79954 5.45849 5.771 5.35437 5.72285 5.25893C5.67469 5.1635 5.6079 5.07868 5.52641 5.00949C5.44493 4.9403 5.3504 4.88815 5.24842 4.8561C5.14644 4.82406 5.03907 4.81278 4.93265 4.82293C4.82624 4.83308 4.72293 4.86446 4.62885 4.91521C4.53476 4.96595 4.4518 5.03504 4.38487 5.11839C2.81701 6.96726 1.92749 9.29609 1.86357 11.7194C1.79964 14.1427 2.56513 16.5152 4.03333 18.4442C5.50153 20.3731 7.58441 21.7429 9.9372 22.3268C12.29 22.9106 14.7716 22.6736 16.9713 21.6548C19.171 20.6361 20.9569 18.8967 22.0333 16.7247C23.1098 14.5526 23.4122 12.0781 22.8907 9.71074C22.3691 7.34336 21.0548 5.22506 19.1652 3.70646C17.2757 2.18787 14.9242 1.36003 12.5001 1.35999ZM11.2841 12.928L7.25847 7.31679C7.20487 7.23976 7.18006 7.14634 7.18838 7.05287C7.19669 6.9594 7.23761 6.87183 7.30396 6.80548C7.37031 6.73912 7.45789 6.69821 7.55135 6.68989C7.64482 6.68158 7.73824 6.70639 7.81527 6.75999L13.4297 10.784C13.6103 10.914 13.7605 11.0818 13.8699 11.2757C13.9793 11.4695 14.0453 11.6848 14.0632 11.9067C14.0812 12.1286 14.0507 12.3517 13.9738 12.5606C13.897 12.7695 13.7757 12.9592 13.6183 13.1166C13.4609 13.274 13.2712 13.3953 13.0623 13.4722C12.8534 13.549 12.6303 13.5795 12.4084 13.5615C12.1865 13.5436 11.9712 13.4776 11.7773 13.3682C11.5835 13.2588 11.4157 13.1086 11.2857 12.928"
                                  fill="#3D57B5"
                                />
                              </svg>
                              <span
                                className="solutioncards"
                                style={{ color: "#3D57B5" }}
                              >
                                {t("meeting.formState.Beep alarm")}
                              </span>
                            </div>
                          </>
                        )}
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12 mt-2 d-flex align-items-center gap-3 ms-1">
                        <span
                          style={{
                            fontFamily: "Inter",
                            fontSize: "12px",
                            fontWeight: 400,
                            lineHeight: "14.52px",
                            textAlign: "left",
                            color: "#8590a3",
                          }}
                        >
                          {t("Privacy")}:
                        </span>
                        <div className="">
                          <div className="d-flex align-items-center flex-wrap">
                            {meeting?.moment_privacy === "public" ? (
                              <Avatar
                                src="/Assets/Tek.png"
                                style={{ borderRadius: "0" }}
                              />
                            ) : meeting?.moment_privacy === "team" ? (
                              <Avatar.Group>
                                {meeting?.moment_privacy_teams_data?.map(
                                  (item) => {
                                    return (
                                      <>
                                        <Tooltip
                                          title={item?.name}
                                          placement="top"
                                        >
                                          <Avatar
                                            size="large"
                                            src={
                                              item?.logo?.startsWith("http")
                                                ? item.logo
                                                : Assets_URL + "/" + item.logo
                                            }
                                          />
                                        </Tooltip>
                                      </>
                                    );
                                  }
                                )}
                              </Avatar.Group>
                            ) : meeting?.moment_privacy ===
                              "participant only" ? (
                              <Avatar.Group>
                                {meeting?.user_with_participants?.map(
                                  (item) => {
                                    return (
                                      <>
                                        <Tooltip
                                          title={item?.full_name}
                                          placement="top"
                                        >
                                          <Avatar
                                            size="large"
                                            src={
                                              item?.participant_image?.startsWith(
                                                "http"
                                              )
                                                ? item.participant_image
                                                : Assets_URL +
                                                  "/" +
                                                  item.participant_image
                                            }
                                          />
                                        </Tooltip>
                                      </>
                                    );
                                  }
                                )}
                              </Avatar.Group>
                            ) : meeting?.moment_privacy ===
                              "tektime members" ? (
                              <img
                                src={
                                  meeting?.user?.enterprise?.logo?.startsWith(
                                    "http"
                                  )
                                    ? meeting?.user?.enterprise?.logo
                                    : Assets_URL +
                                      "/" +
                                      meeting?.user?.enterprise?.logo
                                }
                                alt="Logo"
                                style={{
                                  width: "30px",
                                  height: "30px",
                                  objectFit: "fill",
                                  borderRadius: "50%",
                                }}
                              /> // <Tooltip
                            ) : meeting?.moment_privacy === "enterprise" ? (
                              <Tooltip
                                title={meeting?.user?.enterprise?.name}
                                placement="top"
                              >
                                <img
                                  src={
                                    meeting?.user?.enterprise?.logo?.startsWith(
                                      "http"
                                    )
                                      ? meeting?.user?.enterprise?.logo
                                      : Assets_URL +
                                        "/" +
                                        meeting?.user?.enterprise?.logo
                                  }
                                  alt="Logo"
                                  style={{
                                    width: "30px",
                                    height: "30px",
                                    objectFit: "fill",
                                    borderRadius: "50%",
                                  }}
                                />
                              </Tooltip>
                            ) : meeting?.moment_privacy === "password" ? (
                              <svg
                                width="37px"
                                height="36px"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                <g
                                  id="SVGRepo_tracerCarrier"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                ></g>
                                <g id="SVGRepo_iconCarrier">
                                  {" "}
                                  <path
                                    d="M7 10.0288C7.47142 10 8.05259 10 8.8 10H15.2C15.9474 10 16.5286 10 17 10.0288M7 10.0288C6.41168 10.0647 5.99429 10.1455 5.63803 10.327C5.07354 10.6146 4.6146 11.0735 4.32698 11.638C4 12.2798 4 13.1198 4 14.8V16.2C4 17.8802 4 18.7202 4.32698 19.362C4.6146 19.9265 5.07354 20.3854 5.63803 20.673C6.27976 21 7.11984 21 8.8 21H15.2C16.8802 21 17.7202 21 18.362 20.673C18.9265 20.3854 19.3854 19.9265 19.673 19.362C20 18.7202 20 17.8802 20 16.2V14.8C20 13.1198 20 12.2798 19.673 11.638C19.3854 11.0735 18.9265 10.6146 18.362 10.327C18.0057 10.1455 17.5883 10.0647 17 10.0288M7 10.0288V8C7 5.23858 9.23858 3 12 3C14.7614 3 17 5.23858 17 8V10.0288"
                                    stroke="#000000"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  ></path>{" "}
                                </g>
                              </svg>
                            ) : (
                              <Tooltip
                                title={meeting?.user?.full_name}
                                placement="top"
                              >
                                <Avatar
                                  src={
                                    meeting?.user?.image.startsWith("users/")
                                      ? Assets_URL + "/" + meeting?.user?.image
                                      : meeting?.user?.image
                                  }
                                />
                              </Tooltip>
                            )}

                            <span
                              className={`badge ms-2 ${
                                meeting?.moment_privacy === "private"
                                  ? "solution-badge-red"
                                  : meeting?.moment_privacy === "public"
                                  ? "solution-badge-green"
                                  : meeting?.moment_privacy === "enterprise" ||
                                    meeting?.moment_privacy ===
                                      "participant only" ||
                                    meeting?.moment_privacy ===
                                      "tektime members"
                                  ? "solution-badge-blue"
                                  : meeting?.moment_privacy === "password"
                                  ? "solution-badge-red"
                                  : "solution-badge-yellow"
                              }`}
                              style={{ padding: "3px 8px 3px 8px" }}
                            >
                              {meeting?.moment_privacy === "private"
                                ? t("solution.badge.private")
                                : meeting?.moment_privacy === "public"
                                ? t("solution.badge.public")
                                : meeting?.moment_privacy === "enterprise"
                                ? t("solution.badge.enterprise")
                                : meeting?.moment_privacy === "participant only"
                                ? t("solution.badge.participantOnly")
                                : meeting?.moment_privacy === "tektime members"
                                ? t("solution.badge.membersOnly")
                                : meeting?.moment_privacy === "password"
                                ? t("solution.badge.password")
                                : t("solution.badge.team")}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="paragraph-parent mt-2 ms-1 w-100 position-relative">
                    <span className="paragraph paragraph-images">
                      <div
                        className="html-content-wrapper"
                        dangerouslySetInnerHTML={{
                          __html: meeting?.description || "",
                        }}
                      />
                    </span>

                    {/* <div
                      className="position-absolute top-0 end-0 cursor-pointer"
                      style={{ cursor: "pointer" }}
                      onClick={() => handleEditDescription(meeting)}
                    >
                      <RiEditBoxLine size={20} />
                    </div> */}
                  </div>
                </>
              </div>
            </div>

            {/* --------------------------------------------TABS------------------------------------------------------ */}

            <div className="current_destinations clients-tab">
              <Tab.Container
                className="destination-tabs-container"
                activeKey={activeTab}
                onSelect={(key) => setActiveTab(key)}
              >
                <div className="row align-items-end tabs-header custom-tabs mt-5">
                  <div className="col-md-10">
                    <Nav variant="tabs" className="d-flex flex-wrap gap-3">
                      {/* Contacts tab - ALWAYS include this */}
                      <Nav.Item key="casting" className="tab">
                        <Nav.Link
                          eventKey="casting"
                          className="custom-tab-link"
                        >
                          {t("Casting")}
                          <span
                            className={`${
                              activeTab === "casting" ? "future" : "draft"
                            } ms-2`}
                            style={{ padding: "4px 6px", borderRadius: "8px" }}
                          >
                            {meeting?.guides?.length +
                              meeting?.participants?.length || 0}
                          </span>
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item key="steps" className="tab">
                        <Nav.Link eventKey="steps" className="custom-tab-link">
                          {t("steps")}
                          <span
                            className={`${
                              activeTab === "steps" ? "future" : "draft"
                            } ms-2`}
                            style={{ padding: "4px 6px", borderRadius: "8px" }}
                          >
                            {count?.step_count || 0}
                          </span>
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item key="files" className="tab">
                        <Nav.Link eventKey="files" className="custom-tab-link">
                          {t("meeting.newMeeting.labels.file")}
                          <span
                            className={`${
                              activeTab === "files" ? "future" : "draft"
                            } ms-2`}
                            style={{ padding: "4px 6px", borderRadius: "8px" }}
                          >
                            {count?.file_count || 0}
                          </span>
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item key="discussion" className="tab">
                        <Nav.Link
                          eventKey="discussion"
                          className="custom-tab-link"
                        >
                          {t("meeting.newMeeting.labels.discussion")}
                          <span
                            className={`${
                              activeTab === "discussion" ? "future" : "draft"
                            } ms-2`}
                            style={{ padding: "4px 6px", borderRadius: "8px" }}
                          >
                            {count?.message_count || 0}
                          </span>
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>
                  </div>
                  <div className="col-md-2 d-flex justify-content-end">
                    {activeTab === "casting" && (
                      <div className="cards-section child-2">
                        {meeting?.type === "Newsletter" ? (
                          <button
                            onClick={() => {
                              handleAddParticipant(meeting);
                            }}
                            style={{
                              fontFamily: "Inter",
                              fontSize: "14px",
                              fontWeight: 600,
                              lineHeight: "24px",
                              textAlign: "left",
                              color: " #FFFFFF",
                              background: "#2C48AE",
                              border: 0,
                              outine: 0,
                              padding: "10px 16px",
                              borderRadius: "9px",
                              marginTop: "1.5rem",
                            }}
                          >
                            <svg
                              width="20"
                              height="21"
                              viewBox="0 0 20 21"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M10 0.457031C15.5228 0.457031 20 4.93418 20 10.457C20 15.9798 15.5228 20.457 10 20.457C4.47715 20.457 0 15.9798 0 10.457C0 4.93418 4.47715 0.457031 10 0.457031ZM10 1.95703C5.30558 1.95703 1.5 5.76261 1.5 10.457C1.5 15.1514 5.30558 18.957 10 18.957C14.6944 18.957 18.5 15.1514 18.5 10.457C18.5 5.76261 14.6944 1.95703 10 1.95703ZM10 5.45703C10.4142 5.45703 10.75 5.79282 10.75 6.20703V9.70703H14.25C14.6642 9.70703 15 10.0428 15 10.457C15 10.8712 14.6642 11.207 14.25 11.207H10.75V14.707C10.75 15.1212 10.4142 15.457 10 15.457C9.5858 15.457 9.25 15.1212 9.25 14.707V11.207H5.75C5.33579 11.207 5 10.8712 5 10.457C5 10.0428 5.33579 9.70703 5.75 9.70703H9.25V6.20703C9.25 5.79282 9.5858 5.45703 10 5.45703Z"
                                fill="white"
                              />
                            </svg>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            {t("meeting.formState.Add Abonne")}
                          </button>
                        ) : (
                          <button
                            onClick={() => {
                              handleAddParticipant(meeting);
                            }}
                            style={{
                              fontFamily: "Inter",
                              fontSize: "14px",
                              fontWeight: 600,
                              lineHeight: "24px",
                              textAlign: "left",
                              color: " #FFFFFF",
                              background: "#2C48AE",
                              border: 0,
                              outine: 0,
                              padding: "10px 16px",
                              borderRadius: "9px",
                              marginTop: "1.5rem",
                            }}
                          >
                            <svg
                              width="20"
                              height="21"
                              viewBox="0 0 20 21"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M10 0.457031C15.5228 0.457031 20 4.93418 20 10.457C20 15.9798 15.5228 20.457 10 20.457C4.47715 20.457 0 15.9798 0 10.457C0 4.93418 4.47715 0.457031 10 0.457031ZM10 1.95703C5.30558 1.95703 1.5 5.76261 1.5 10.457C1.5 15.1514 5.30558 18.957 10 18.957C14.6944 18.957 18.5 15.1514 18.5 10.457C18.5 5.76261 14.6944 1.95703 10 1.95703ZM10 5.45703C10.4142 5.45703 10.75 5.79282 10.75 6.20703V9.70703H14.25C14.6642 9.70703 15 10.0428 15 10.457C15 10.8712 14.6642 11.207 14.25 11.207H10.75V14.707C10.75 15.1212 10.4142 15.457 10 15.457C9.5858 15.457 9.25 15.1212 9.25 14.707V11.207H5.75C5.33579 11.207 5 10.8712 5 10.457C5 10.0428 5.33579 9.70703 5.75 9.70703H9.25V6.20703C9.25 5.79282 9.5858 5.45703 10 5.45703Z"
                                fill="white"
                              />
                            </svg>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            {t("meeting.formState.Add Invitee")}
                          </button>
                        )}
                      </div>
                    )}

                    {activeTab === "steps" && (
                      <div className="invite-buttons">
                        {/* {meeting?.status === "in_progress" && ( */}
                        <button
                          onClick={() => {
                            // stepModal(meeting);
                            setIsDrop(true);

                            setIsUpdated(false);
                            setShowModal(true);
                            // setOpen1(false);
                          }}
                          style={{
                            fontFamily: "Inter",
                            fontSize: "14px",
                            fontWeight: 600,
                            lineHeight: "24px",
                            textAlign: "left",
                            color: " #FFFFFF",
                            background: "#2C48AE",
                            border: 0,
                            outine: 0,
                            padding: "10px 16px",
                            borderRadius: "9px",
                            // marginTop: "1.5rem",
                          }}
                        >
                          <svg
                            width="20"
                            height="21"
                            viewBox="0 0 20 21"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10 0.457031C15.5228 0.457031 20 4.93418 20 10.457C20 15.9798 15.5228 20.457 10 20.457C4.47715 20.457 0 15.9798 0 10.457C0 4.93418 4.47715 0.457031 10 0.457031ZM10 1.95703C5.30558 1.95703 1.5 5.76261 1.5 10.457C1.5 15.1514 5.30558 18.957 10 18.957C14.6944 18.957 18.5 15.1514 18.5 10.457C18.5 5.76261 14.6944 1.95703 10 1.95703ZM10 5.45703C10.4142 5.45703 10.75 5.79282 10.75 6.20703V9.70703H14.25C14.6642 9.70703 15 10.0428 15 10.457C15 10.8712 14.6642 11.207 14.25 11.207H10.75V14.707C10.75 15.1212 10.4142 15.457 10 15.457C9.5858 15.457 9.25 15.1212 9.25 14.707V11.207H5.75C5.33579 11.207 5 10.8712 5 10.457C5 10.0428 5.33579 9.70703 5.75 9.70703H9.25V6.20703C9.25 5.79282 9.5858 5.45703 10 5.45703Z"
                              fill="white"
                            />
                          </svg>
                          &nbsp;&nbsp;&nbsp;&nbsp;
                          {t("addTask")}
                        </button>
                      </div>
                    )}

                    {activeTab === "files" && (
                      <div className="invite-buttons mt-3">
                        <input
                          type="file"
                          id="fileInput"
                          // accept="application/pdf"
                          accept="
                          application/pdf,
                          application/vnd.ms-excel,
                          application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                          application/vnd.ms-powerpoint,
                          application/vnd.openxmlformats-officedocument.presentationml.presentation,
                          application/msword,
                          application/vnd.openxmlformats-officedocument.wordprocessingml.document,
                          image/png,
                          image/webp
                          video/mp4,
                          video/x-msvideo,
                          video/x-matroska,
                          video/mpeg,
                          video/quicktime"
                          style={{ display: "none" }}
                          onChange={handleFileChange}
                        />
                        <button
                          onClick={() => setShowFileModal(true)}
                          style={{
                            fontFamily: "Inter",
                            fontSize: "14px",
                            fontWeight: 600,
                            lineHeight: "24px",
                            textAlign: "left",
                            color: "#FFFFFF",
                            background: "#2C48AE",
                            border: 0,
                            outline: 0,
                            padding: "10px 16px",
                            borderRadius: "9px",
                            marginTop: "20px",
                          }}
                        >
                          <svg
                            width="20"
                            height="21"
                            viewBox="0 0 20 21"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10 0.457031C15.5228 0.457031 20 4.93418 20 10.457C20 15.9798 15.5228 20.457 10 20.457C4.47715 20.457 0 15.9798 0 10.457C0 4.93418 4.47715 0.457031 10 0.457031ZM10 1.95703C5.30558 1.95703 1.5 5.76261 1.5 10.457C1.5 15.1514 5.30558 18.957 10 18.957C14.6944 18.957 18.5 15.1514 18.5 10.457C18.5 5.76261 14.6944 1.95703 10 1.95703ZM10 5.45703C10.4142 5.45703 10.75 5.79282 10.75 6.20703V9.70703H14.25C14.6642 9.70703 15 10.0428 15 10.457C15 10.8712 14.6642 11.207 14.25 11.207H10.75V14.707C10.75 15.1212 10.4142 15.457 10 15.457C9.5858 15.457 9.25 15.1212 9.25 14.707V11.207H5.75C5.33579 11.207 5 10.8712 5 10.457C5 10.0428 5.33579 9.70703 5.75 9.70703H9.25V6.20703C9.25 5.79282 9.5858 5.45703 10 5.45703Z"
                              fill="white"
                            />
                          </svg>
                          &nbsp;&nbsp;&nbsp;&nbsp;
                          {t("addFile")}
                        </button>
                      </div>
                    )}
                  </div>
                </div>

                <Tab.Content className="mt-3">
                  <Tab.Pane eventKey="casting">
                    <div className="row d-flex justify-content-center">
                      <div
                        className="col-md-12 mb-3 position-relative"
                        // style={{ minHeight: "300px" }}
                      >
                        {/* --------------Organisator */}
                        <div style={{ marginTop: "4rem" }}>
                          <h4 className="participant-heading-meeting">
                            {showOrgProfile && (
                              <IoArrowBackSharp
                                onClick={hideOrgShow}
                                size={25}
                                style={{
                                  cursor: "pointer",
                                  marginRight: "1rem",
                                }}
                              />
                            )}
                            {t("Creator")}
                          </h4>
                          <div
                            className="host"
                            style={{
                              background: showOrgProfile && "white",
                            }}
                          >
                            <HostCard
                              data={meeting?.user}
                              guides={meeting?.user_with_participants?.filter(
                                (item) => item?.email === meeting?.user?.email
                              )}
                              handleShow={handleOrgShow}
                              handleHide={hideOrgShow}
                              showProfile={showOrgProfile}
                              meeting={meeting}
                            />
                          </div>
                        </div>

                        {/* ---------------GUides */}
                        <div style={{ marginTop: "4rem" }}>
                          <h4 className="participant-heading-meeting">
                            {showHostProfile && (
                              <IoArrowBackSharp
                                onClick={hideHostShow}
                                size={25}
                                style={{
                                  cursor: "pointer",
                                  marginRight: "1rem",
                                }}
                              />
                            )}
                            {meeting?.guides?.length > 1 ? "Guides" : "Guide"}
                          </h4>
                          <div
                            className="host"
                            style={{
                              background: showHostProfile && "white",
                            }}
                          >
                            <HostCard
                              data={meeting?.user}
                              participants={meeting?.participants}
                              guides={meeting?.guides}
                              handleShow={handleHostShow}
                              handleHide={hideHostShow}
                              showProfile={showHostProfile}
                              meeting={meeting}
                            />
                          </div>
                        </div>
                        {/* ------------------------------------------------ Participants */}

                        {meeting?.type !== "Newsletter" && (
                          <>
                            {meeting?.participants?.filter(
                              (item) =>
                                // item.isCreator === 0 &&
                                !guideEmails?.has(item.email)
                            )?.length > 0 && (
                              <div style={{ marginTop: "3rem" }}>
                                <h4 className="participant-heading-meeting">
                                  {showProfile && (
                                    <IoArrowBackSharp
                                      onClick={hideShow}
                                      size={25}
                                      style={{
                                        cursor: "pointer",
                                        marginRight: "1rem",
                                      }}
                                    />
                                  )}

                                  {t("invite")}
                                </h4>
                                <div
                                  className="participant"
                                  style={{
                                    background: showProfile && "white",
                                  }}
                                >
                                  <ParticipantCard
                                    guides={meeting?.guides}
                                    data={meeting?.participants}
                                    meeting={meeting}
                                    handleShow={handleShow1}
                                    handleHide={hideShow}
                                    showProfile={showProfile}
                                  />
                                </div>
                              </div>
                            )}
                          </>
                        )}
                        {meeting?.type === "Newsletter" && (
                          <div
                            style={{
                              marginTop: "3rem",
                              marginBottom: "3rem",
                            }}
                          >
                            <h4 className={"participant-heading-meeting"}>
                              {t("Abonnés")}
                            </h4>

                            <div
                              className="participant"
                              style={{ background: showProfile && "white" }}
                            >
                              <div style={{ marginTop: "5rem" }}>
                                <SubscriberCard
                                  subscribers={meeting?.newsletter_subscribers}
                                  data={meeting?.newsletter_subscribers}
                                  meeting={meeting}
                                  handleShow={handleShow1}
                                  handleHide={hideShow}
                                  showProfile={showProfile}
                                />
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </Tab.Pane>
                  {/* ------------------------------------------------ Steps */}
                  <Tab.Pane eventKey="steps">
                    <div className="row d-flex justify-content-center">
                      <div className="col-md-12 mb-3">

                        <div
                          style={{
                            marginTop: "3rem",
                            marginBottom: "3rem",
                          }}
                        >
                          <h4
                            className={`participant-heading-meeting d-flex align-items-center justify-content-between`}
                          >
                            {meetingSteps?.length > 1
                              ? t("steps")
                              : t("step")}

                            <span style={{ cursor: "pointer" }}>
                              <div className="toggle-button">
                                <button
                                  className={`toggle-button-option ${
                                    view === "list" ? "active" : ""
                                  }`}
                                  onClick={() => handleToggle("list")}
                                >
                                  <div className="icon-list" />
                                  <FaList size={18} />
                                </button>
                                <button
                                  className={`toggle-button-option ${
                                    view === "graph" ? "active" : ""
                                  }`}
                                  onClick={() => handleToggle("graph")}
                                >
                                  <div className="icon-graph" />
                                  <FaChartGantt size={20} />
                                </button>
                              </div>
                            </span>
                          </h4>

                          {view === "graph" ? (
                            <InviteStepChart
                              meetingId={meeting?.id}
                              steps={meetingSteps}
                              meeting={meeting}
                              refreshMeeting={getRefreshMeeting}
                            />
                          ) : (
                            <StepCard
                              data={meetingSteps}
                              startTime={formattedTime}
                              users={{
                                ...meeting?.user,
                                firstName: meeting?.user?.name,
                                lastName: meeting?.user?.last_name,
                                image:
                                  // meeting?.user?.assigned_to_image ||
                                  meeting?.user?.image || "/Assets/avatar.jpeg",
                              }}
                              meeting={meeting}
                              refreshMeeting={getRefreshMeeting}
                            />
                          )}
                        </div>
                      </div>

                      <div className="invite-buttons">
                        <h5 className="estimated-font">
                          {meetingSteps &&
                            `${t("estimateFieldActive")}: ${totalTime}`}
                        </h5>
                      </div>
                    </div>
                  </Tab.Pane>

                  <Tab.Pane eventKey="files">
                    <div className="row d-flex justify-content-center">
                      <div className="col-md-12 mb-3">
                        {/* ------------------------------------------------ Files */}
                        <div
                          style={{
                            marginTop: "3rem",
                            marginBottom: "3rem",
                          }}
                        >
                          <h4 className="participant-heading-meeting">
                            {`${t("meeting.newMeeting.labels.file")} `}
                          </h4>
                          <StepFile
                            isFileUploaded={isFileUploaded}
                            setIsFileUploaded={setIsFileUploaded}
                            openModal={openModal}
                            meetingFiles={meetingFiles}
                          />
                          {isModalOpen && (
                            <ViewFilePreview
                              isModalOpen={isModalOpen}
                              setIsModalOpen={setIsModalOpen}
                              modalContent={modalContent}
                              closeModal={closeModal}
                              isFileUploaded={isFileUploaded}
                              setIsFileUploaded={setIsFileUploaded}
                              refreshMeeting={refreshFiles}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </Tab.Pane>

                  <Tab.Pane eventKey="discussion">
                    <div className="row d-flex justify-content-center">
                      <div className="col-md-12 mb-3">
                        <MeetingDiscussion
                          meetingId={id}
                          messages={meetingMessages}
                          selectedMoment={meeting}
                          onMessagesUpdate={(newMeetings) =>
                            setMeetingMessages(newMeetings)
                          }
                        />
                      </div>
                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </div>
          </div>
        </div>
      )}
      {open && (
        <div className="tabs-container container-fluid">
          <NewMeetingModal open={open} closeModal={handleCloseModal} />
        </div>
      )}

      {showConfirmationModal && (
        <ConfirmationModal
          message={t("meetingDeletedToast")}
          onConfirm={(e) => confirmDelete(e)}
          onCancel={(e) => {
            e.stopPropagation();
            setShowConfirmationModal(false);
          }}
        />
      )}
      {showPlayConfirmationModal && (
        <ConfirmationModal
          message={t("errors.playmsg")}
          onConfirm={(e) => handleConfirmPlay(e)}
          onCancel={(e) => {
            e.stopPropagation();
            setShowPlayConfirmationModal(false);
          }}
        />
      )}

      {visoModal && (
        <ConfirmationModal
          message={t("Do you want to open the visioconference in a new tab?")}
          onCancel={handleClose}
          onConfirm={handleConfirm}
        />
      )}
      {showConfirmationCancelModal && (
        <ConfirmationModal
          message={t("confirmation")}
          onConfirm={(e) => updateMeetingStatus(e, meeting, navigate)}
          onCancel={(e) => {
            e.stopPropagation();
            setShowConfirmationCancelModal(false);
          }}
        />
      )}
      {showModal && (
        <div className="new-meeting-modal tabs-container">
          <StepChart
            meetingId={meeting?.id}
            id={newId}
            show={showModal}
            setId={setNewId}
            closeModal={handleCloseModal}
            isDrop={isDrop}
            setIsDrop={setIsDrop}
            setIsDropFile={setIsDropFile}
            meeting={meeting}
            setMeeting={setMeeting}
            refreshMeeting={getRefreshMeeting}
          />
        </div>
      )}
      {showFileModal && (
        <div className="file-modal-overlay">
          <div
            className="file-modal-content w-100 h-100"
            style={{ background: "rgb(242, 244, 251)" }}
          >
            <button
              className="file-modal-close"
              onClick={() => setShowFileModal(false)}
            >
              ×
            </button>
            <FileUploadModal
              meetingId={meeting?.id}
              setShowFileModal={setShowFileModal}
              isFileUploaded={isFileUploaded}
              setIsFileUploaded={setIsFileUploaded}
              refreshMeeting={refreshFiles}
            />
          </div>
        </div>
      )}

      {isCloseMomentModalOpen && (
        <Modal
          show={isCloseMomentModalOpen}
          onHide={() => setIsCloseMomentModalOpen(false)}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>{t("Select moment end time")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group controlId="datetime">
                <Form.Label>{t("Select Date and Time")}</Form.Label>
                <Form.Control
                  type="datetime-local"
                  value={closeMomentDateTime}
                  onChange={(e) => setCloseMomentDateTime(e.target.value)}
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setIsCloseMomentModalOpen(false)}
            >
              {t("Cancel")}
            </Button>
            <Button
              variant="primary"
              // onClick={() => setIsConfirmCloseMomentOpen(true)}
              onClick={() => {
                setIsCloseMomentModalOpen(false); // Close first modal
                setIsConfirmCloseMomentOpen(true); // Open confirmation modal
              }}
            >
              {t("Validate")}
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      {isConfirmCloseMomentOpen && (
        <Modal
          show={isConfirmCloseMomentOpen}
          onHide={() => setIsConfirmCloseMomentOpen(false)}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {t(
                "Are you sure you want to close the moment at this date and time?"
              )}
            </Modal.Title>
          </Modal.Header>
          <Modal.Footer>
            <Button variant="danger" onClick={handleCloseMoment}>
              {t("Yes, confirm")}
            </Button>
            <Button
              variant="secondary"
              onClick={() => {
                setIsConfirmCloseMomentOpen(false);
                setIsCloseMomentModalOpen(true); // open first modal
              }}
            >
              {t("No, cancel")}
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      {editingField && (
        <Modal
          show={true}
          onHide={() => setEditingField(null)}
          centered
          backdrop="static"
          size={editingField === "description" ? "xl" : "md"} // xl for description, lg for title
          dialogClassName={
            editingField === "description" ? "description-edit-modal" : ""
          }
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {t("edit")} {t(`fieldNames.${editingField}`)}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {editingField === "description" ? (
              <Editor
                apiKey={APIKEY}
                onInit={(evt, editor) => (editorRef.current = editor)}
                value={editValue}
                onEditorChange={handleEditorChange}
                init={{
                  height: 480,
                  menubar: true,
                  plugins: [
                    "advlist autolink lists link image charmap print preview anchor",
                    "searchreplace visualblocks code fullscreen",
                    "insertdatetime media table paste code help wordcount",
                    "image",
                    "imagetools",
                  ],
                  toolbar:
                    "undo redo | formatselect | bold italic underline | \
                  alignleft aligncenter alignright alignjustify | \
                  bullist numlist outdent indent | link image | \
                  code | fullscreen | help",

                  /* Cloudinary Image Handling */
                  automatic_uploads: true,
                  images_upload_handler: async (blobInfo, progress) => {
                    progress(0);
                    try {
                      const url = await uploadToCloudinary(blobInfo);
                      progress(100);
                      return url;
                    } catch (error) {
                      progress(0);
                      throw error;
                    }
                  },

                  /* Enable all image input methods */
                  paste_data_images: true,
                  file_picker_types: "image",

                  /* Image enhancements */
                  image_caption: true,
                  image_advtab: true,
                  image_title: true,

                  // 🟢 Enable resizing images with the mouse
                  resize_img_proportional: true, // Optional: constrain proportions
                  object_resizing: true, // or 'img' to target only images
                  image_dimensions: true, // shows width/height fields and supports inline sizing

                  image_class_list: [
                    { title: "Responsive", value: "img-responsive" },
                    { title: "Rounded", value: "img-rounded" },
                  ],

                  /* Responsive images by default */
                  content_style: `
                 
                  img.img-rounded { border-radius: 8px; }
                `,
                }}
              />
            ) : (
              <input
                type="text"
                className="form-control"
                value={editValue}
                onChange={(e) => setEditValue(e.target.value)}
              />
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="danger" onClick={() => setEditingField(null)}>
              {t("Cancel")}
            </Button>
            <button
              className="btn"
              style={{
                background: "#0026b1",
                color: "white",
                fontFamily: "Inter",
                fontSize: "14px",
                fontWeight: 500,
                lineHeight: "20px",
                textAlign: "left",
                padding: "10px 16px",
              }}
              onClick={handleSaveEdit}
            >
              {t("Validate")}
            </button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};

export default Invite;
